(function () {
  "use strict";

  document.documentElement.classList.add("js-enabled");
  const isShopifyDesignMode = Boolean(window.Shopify && window.Shopify.designMode);
  if (isShopifyDesignMode) {
    document.documentElement.classList.add("shopify-design-mode");
  }

  const sectionSelectors = {
    "header": "#shopify-section-header",
    "cart-drawer": "#shopify-section-cart-drawer",
    "main": "body.cart-page #main > .shopify-section"
  };
  const cartUrl = document.body?.getAttribute("data-cart-url") || "/cart";
  const newsletterScrollKey = "theme-newsletter-scroll";
  const newsletterStateKey = "theme-newsletter-state";
  const neutralSwatchColor = "#cccccc";
  let cartDrawerScrollFallbackTimer = null;
  const colorSwatchMap = {
    black: "#000000",
    white: "#ffffff",
    grey: "#808080",
    gray: "#808080",
    charcoal: "#36454f",
    "off white": "#faf9f6",
    stone: "#b2a38b",
    cream: "#fffdd0",
    beige: "#f5f5dc",
    sand: "#c2b280",
    camel: "#c19a6b",
    champagne: "#f7e7ce",
    pearl: "#eae0c8",
    neutral: "#e8e0d5",
    ivory: "#fffff0",
    brown: "#964b00",
    chocolate: "#7b3f00",
    tan: "#d2b48c",
    mocha: "#967969",
    red: "#ff0000",
    burgundy: "#800020",
    wine: "#722f37",
    maroon: "#800000",
    rose: "#ff007f",
    coral: "#ff6b6b",
    rust: "#b7410e",
    pink: "#ffc0cb",
    blush: "#ffb6c1",
    "dusty pink": "#dcae96",
    "hot pink": "#ff69b4",
    mauve: "#e0b0ff",
    orange: "#ffa500",
    peach: "#ffcba4",
    terracotta: "#e2725b",
    yellow: "#ffff00",
    mustard: "#ffdb58",
    gold: "#ffd700",
    green: "#008000",
    olive: "#808000",
    forest: "#228b22",
    sage: "#b2ac88",
    mint: "#98ff98",
    khaki: "#c3b091",
    "hunter green": "#355e3b",
    blue: "#0000ff",
    "royal blue": "#4169e1",
    navy: "#000080",
    "sky blue": "#87ceeb",
    "baby blue": "#89cff0",
    cobalt: "#0047ab",
    denim: "#1560bd",
    "mid wash": "#5b7fa6",
    "light wash": "#a8c5d8",
    "dark wash": "#2f4f6b",
    teal: "#008080",
    turquoise: "#40e0d0",
    petrol: "#005f6a",
    purple: "#800080",
    lavender: "#e6e6fa",
    lilac: "#c8a2c8",
    violet: "#ee82ee",
    plum: "#dda0dd",
    multi: "#ff6b6b"
  };
  const reviewsIoRatingSnippetSelector = ".ruk_rating_snippet";
  const reviewsIoRatingSnippetConfig = {
    store: "www.malayapparel.co.uk-gP310wx",
    mode: "default",
    color: "#0E1311",
    linebreak: false,
    text: "Reviews",
    singularText: "Review",
    lang: "en",
    usePolaris: true,
    showEmptyStars: false,
    showNumericalAverageRating: false
  };
  let reviewsIoRatingSnippetTimer = null;
  const legacyFullOutfitsPath = "/collections/full-outfits";
  const fullOutfitsPath = "/collections/outfits?sort_by=manual";

  const isLegacyFullOutfitsUrl = (href) => {
    if (!href) {
      return false;
    }

    try {
      return new URL(href, window.location.origin).pathname === legacyFullOutfitsPath;
    } catch (_error) {
      return href.split("?")[0] === legacyFullOutfitsPath;
    }
  };

  const normalizeLegacyFullOutfitsLinks = (root = document) => {
    const scope = root && typeof root.querySelectorAll === "function" ? root : document;
    scope.querySelectorAll("a[href]").forEach((link) => {
      if (isLegacyFullOutfitsUrl(link.getAttribute("href"))) {
        link.setAttribute("href", fullOutfitsPath);
      }
    });
  };

  const redirectLegacyFullOutfitsPage = () => {
    if (window.location.pathname === legacyFullOutfitsPath) {
      window.location.replace(fullOutfitsPath);
    }
  };

  const initReviewsIoRatingSnippets = (root = document) => {
    if (isShopifyDesignMode) {
      return;
    }

    const scope = root && typeof root.querySelector === "function" ? root : document;
    if (!scope.querySelector(reviewsIoRatingSnippetSelector)) {
      return;
    }

    window.clearTimeout(reviewsIoRatingSnippetTimer);
    reviewsIoRatingSnippetTimer = window.setTimeout(() => {
      if (typeof window.ratingSnippet !== "function") {
        return;
      }

      if (typeof window.themeInitReviewsIoRatingSnippets === "function") {
        window.themeInitReviewsIoRatingSnippets();
        return;
      }

      const config = window.themeReviewsIoRatingSnippetConfig || reviewsIoRatingSnippetConfig;
      window.ratingSnippet("ruk_rating_snippet", config);
    }, 0);
  };

  const closeAllDesktopMenus = () => {
    document.querySelectorAll(".primary-nav .nav-item").forEach((item) => {
      item.classList.remove("is-open");
      item.querySelector(".nav-trigger")?.setAttribute("aria-expanded", "false");
    });
  };

  const openDesktopMenu = (activeItem) => {
    document.querySelectorAll(".primary-nav .nav-item").forEach((item) => {
      const isActive = item === activeItem;
      item.classList.toggle("is-open", isActive);
      item.querySelector(".nav-trigger")?.setAttribute("aria-expanded", String(isActive));
    });
  };

  const setDelayedHidden = (element, shouldHide, duration = 380) => {
    if (!(element instanceof HTMLElement)) {
      return;
    }

    const existingTimer = Number(element.dataset.hideTimer || 0);
    if (existingTimer) {
      window.clearTimeout(existingTimer);
    }

    if (!shouldHide) {
      element.hidden = false;
      delete element.dataset.hideTimer;
      return;
    }

    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const hideDelay = prefersReducedMotion ? 0 : duration;
    const hideTimer = window.setTimeout(() => {
      element.hidden = true;
      delete element.dataset.hideTimer;
    }, hideDelay);

    element.dataset.hideTimer = String(hideTimer);
  };

  const setMobileMenuOpen = (isOpen) => {
    const mobileMenuToggle = document.querySelector(".mobile-menu-toggle");
    const mobileNavOverlay = document.querySelector(".mobile-nav-overlay");
    const mobileNavDrawer = document.querySelector(".mobile-nav-drawer");

    if (isOpen) {
      setDelayedHidden(mobileNavOverlay, false);
    }
    document.body.classList.toggle("mobile-nav-open", isOpen);
    mobileMenuToggle?.setAttribute("aria-expanded", String(isOpen));
    if (!isOpen) {
      setDelayedHidden(mobileNavOverlay, true);
    }
    mobileNavDrawer?.setAttribute("aria-hidden", String(!isOpen));
  };

  const setCartDrawerOpen = (isOpen) => {
    const cartOverlay = document.querySelector(".cart-overlay");
    const cartDrawer = document.querySelector(".cart-drawer");
    const cartToggle = document.querySelector("[data-cart-toggle]");

    if (isOpen) {
      setDelayedHidden(cartOverlay, false);
    }
    document.body.classList.toggle("cart-open", isOpen);
    if (!isOpen) {
      setDelayedHidden(cartOverlay, true);
    }
    cartDrawer?.setAttribute("aria-hidden", String(!isOpen));
    cartToggle?.setAttribute("aria-expanded", String(isOpen));
    if (isOpen) {
      eagerLoadCartDrawerImages();
      bindCartDrawerImageWarmup();
    }
  };

  const scrollCartDrawerToItems = () => {
    if (!window.matchMedia("(max-width: 820px)").matches) {
      return;
    }

    const cartDrawer = document.querySelector(".cart-drawer");
    if (!(cartDrawer instanceof HTMLElement)) {
      return;
    }

    const candidates = [
      cartDrawer.querySelector(".cart-body"),
      cartDrawer,
      ...Array.from(cartDrawer.querySelectorAll("*"))
    ].filter((element) => element instanceof HTMLElement);
    const scrollContainer = candidates.find((element) => {
      const styles = window.getComputedStyle(element);
      const canScrollY = /(auto|scroll)/.test(styles.overflowY);
      return canScrollY && element.scrollHeight > element.clientHeight + 2;
    }) || cartDrawer.querySelector(".cart-body");

    if (!(scrollContainer instanceof HTMLElement)) {
      return;
    }

    const targetTop = 0;
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    window.clearTimeout(cartDrawerScrollFallbackTimer);

    if (prefersReducedMotion) {
      scrollContainer.scrollTop = targetTop;
      return;
    }

    scrollContainer.scrollTo({ top: targetTop, left: 0, behavior: "smooth" });
    cartDrawerScrollFallbackTimer = window.setTimeout(() => {
      if (scrollContainer.scrollTop > 12) {
        scrollContainer.scrollTop = targetTop;
      }
      cartDrawerScrollFallbackTimer = null;
    }, 850);
  };

  const primeImageLoad = (image, priority = "low") => {
    if (!(image instanceof HTMLImageElement)) {
      return;
    }
    if (image.complete && image.naturalWidth > 0) {
      return;
    }

    image.loading = "eager";
    if ("fetchPriority" in image && !image.getAttribute("fetchpriority")) {
      image.fetchPriority = priority;
    }
  };

  const primePanelImages = (panel) => {
    if (!(panel instanceof HTMLElement)) {
      return;
    }

    panel.querySelectorAll('img[loading="lazy"]').forEach((image) => primeImageLoad(image));
  };

  const setSearchOpen = (isOpen) => {
    const searchOverlay = document.querySelector(".search-overlay");
    const searchPanel = document.querySelector(".search-panel");
    const searchToggle = document.querySelector("[data-search-toggle]");
    const searchInput = document.querySelector(".search-form input[name='q']");
    const searchClear = document.querySelector(".search-clear");
    const searchSuggestions = document.querySelector(".search-suggestions");
    const searchResults = document.querySelector(".search-results");
    const searchEmpty = document.querySelector("[data-search-empty]");

    if (isOpen) {
      setDelayedHidden(searchOverlay, false);
    }
    document.body.classList.toggle("search-open", isOpen);
    if (!isOpen) {
      setDelayedHidden(searchOverlay, true);
    }
    searchPanel?.setAttribute("aria-hidden", String(!isOpen));
    searchToggle?.setAttribute("aria-expanded", String(isOpen));

    if (isOpen) {
      primePanelImages(searchPanel);
      if (searchInput && !searchInput.value.trim()) {
        searchSuggestions?.removeAttribute("hidden");
        searchResults?.setAttribute("hidden", "");
        searchResults?.classList.remove("is-query-active");
        searchEmpty?.setAttribute("hidden", "");
      }
      window.setTimeout(() => {
        searchInput?.focus();
        searchInput?.select();
      }, 20);
    } else if (searchClear) {
      searchClear.hidden = !(searchInput && searchInput.value);
    }
  };

  const refreshSections = async (sectionNames, basePath = window.location.pathname) => {
    const url = new URL(basePath, window.location.origin);
    url.searchParams.set("sections", sectionNames.join(","));
    const response = await fetch(url.toString(), { headers: { Accept: "application/json" } });
    if (!response.ok) {
      throw new Error(`Section refresh failed: ${response.status}`);
    }

    const payload = await response.json();
    return applySectionPayload(payload, sectionNames);
  };

  const refreshCartPageContent = async () => {
    if (!document.body.classList.contains("cart-page")) {
      return false;
    }

    const currentMain = document.querySelector("#main");
    if (!(currentMain instanceof HTMLElement)) {
      return false;
    }

    const response = await fetch(cartUrl, {
      headers: { Accept: "text/html" }
    });
    if (!response.ok) {
      throw new Error(`Cart page refresh failed: ${response.status}`);
    }

    const html = await response.text();
    const parsedHtml = new DOMParser().parseFromString(html, "text/html");
    const returnedMain = parsedHtml.querySelector("#main");
    if (!(returnedMain instanceof HTMLElement)) {
      throw new Error("Cart page refresh did not include #main.");
    }

    currentMain.innerHTML = returnedMain.innerHTML;
    initProductCardSwatches(currentMain);
    initReviewsIoRatingSnippets();
    return true;
  };

  const applySectionPayload = (payload, sectionNames) => {
    const refreshedContainers = [];
    const refreshedSectionNames = [];
    sectionNames.forEach((sectionName) => {
      const container = document.querySelector(sectionSelectors[sectionName]);
      const html = payload[sectionName];
      if (container && html) {
        const parsedHtml = new DOMParser().parseFromString(html, "text/html");
        const returnedSelector = sectionName === "main" ? "#main > .shopify-section, .shopify-section" : sectionSelectors[sectionName];
        const returnedContainer = parsedHtml.querySelector(returnedSelector);
        container.innerHTML = returnedContainer ? returnedContainer.innerHTML : html;
        refreshedContainers.push(container);
        refreshedSectionNames.push(sectionName);
      }
    });
    refreshedContainers.forEach((container) => initProductCardSwatches(container));
    initReviewsIoRatingSnippets();
    if (refreshedSectionNames.includes("cart-drawer") && document.body.classList.contains("cart-open")) {
      bindCartDrawerImageWarmup();
      eagerLoadCartDrawerImages();
    }
    return refreshedSectionNames;
  };

  const moneyFormatter = new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP"
  });

  const formatMoney = (cents) => moneyFormatter.format((Number(cents) || 0) / 100);

  const getQuantityBreakPercent = (quantity) => {
    const lineQuantity = Math.max(0, Number(quantity) || 0);
    if (lineQuantity >= 3) return 15;
    if (lineQuantity === 2) return 10;
    return 0;
  };

  const getQuantityBreakLinePrice = (unitPriceCents, quantity, isEligible = true) => {
    const lineQuantity = Math.max(0, Number(quantity) || 0);
    const originalTotal = Math.max(0, Number(unitPriceCents) || 0) * lineQuantity;
    if (!isEligible) {
      return originalTotal;
    }

    const discountPercent = getQuantityBreakPercent(lineQuantity);
    if (discountPercent <= 0) {
      return originalTotal;
    }

    return Math.round(originalTotal * ((100 - discountPercent) / 100));
  };

  const syncHeaderCartCount = (itemCount) => {
    const cartToggle = document.querySelector("[data-cart-toggle]");
    if (!(cartToggle instanceof HTMLElement)) {
      return;
    }

    let badge = cartToggle.querySelector(".cart-badge");
    if (itemCount > 0) {
      if (!(badge instanceof HTMLElement)) {
        badge = document.createElement("span");
        badge.className = "cart-badge";
        cartToggle.append(badge);
      }
      badge.textContent = String(itemCount);
    } else {
      badge?.remove();
    }
  };

  const syncCartFallbackDisplay = (cart) => {
    if (!cart || !Array.isArray(cart.items)) {
      return false;
    }

    const itemCount = Number(cart.item_count) || 0;
    const subtotal = Number(cart.total_price) || 0;
    const countText = `${itemCount} item${itemCount === 1 ? "" : "s"}`;

    syncHeaderCartCount(itemCount);

    document.querySelectorAll(".cart-head span").forEach((element) => {
      element.textContent = countText;
    });

    document.querySelectorAll(".cart-drawer .cart-summary > div:first-child strong, [data-cart-page-subtotal]").forEach((element) => {
      element.textContent = formatMoney(subtotal);
    });

    document.querySelectorAll("[data-cart-page-count]").forEach((element) => {
      element.textContent = itemCount > 0 ? `${countText} in your bag.` : "Add a few proven pieces, then review everything here before checkout.";
    });

    return true;
  };

  const fetchCartJson = async () => {
    const response = await fetch("/cart.js", {
      headers: { Accept: "application/json" }
    });

    if (!response.ok) {
      throw new Error(`Cart fetch failed: ${response.status}`);
    }

    return response.json();
  };

  const initNavigation = () => {
    if (document.body.dataset.navigationBound === "true") {
      return;
    }
    document.body.dataset.navigationBound = "true";

    const header = document.querySelector(".site-header");
    const navItems = Array.from(document.querySelectorAll(".primary-nav .nav-item"));
    const mobileMenuToggle = document.querySelector(".mobile-menu-toggle");
    const mobileNavOverlay = document.querySelector(".mobile-nav-overlay");
    const mobileNavClose = document.querySelector(".mobile-nav-close");

    if (header && navItems.length) {
      let headerScrollTicking = false;
      const syncHeaderScrollState = () => {
        header.classList.toggle("is-scrolled", window.scrollY > 10);
        headerScrollTicking = false;
      };

      const requestHeaderScrollSync = () => {
        if (headerScrollTicking) {
          return;
        }

        headerScrollTicking = true;
        window.requestAnimationFrame(syncHeaderScrollState);
      };

      if (!isShopifyDesignMode) {
        syncHeaderScrollState();
        window.addEventListener("scroll", requestHeaderScrollSync, { passive: true });
      }

      const desktopHoverQuery = window.matchMedia("(hover: hover) and (pointer: fine)");
      let desktopMenuCloseTimer = null;

      const cancelDesktopMenuClose = () => {
        if (!desktopMenuCloseTimer) {
          return;
        }

        window.clearTimeout(desktopMenuCloseTimer);
        desktopMenuCloseTimer = null;
      };

      const scheduleDesktopMenuClose = () => {
        cancelDesktopMenuClose();
        desktopMenuCloseTimer = window.setTimeout(() => {
          closeAllDesktopMenus();
          desktopMenuCloseTimer = null;
        }, 90);
      };

      const isMenuElement = (target) => target instanceof Element && Boolean(target.closest(".primary-nav .nav-item, .primary-nav .mega-menu"));

      const isPointerInOpenMenuPath = (event) => {
        const activeItem = header.querySelector(".primary-nav .nav-item.is-open");
        const activeMenu = activeItem?.querySelector(".mega-menu");

        if (!activeItem || !activeMenu) {
          return false;
        }

        const itemRect = activeItem.getBoundingClientRect();
        const menuRect = activeMenu.getBoundingClientRect();
        const x = event.clientX;
        const y = event.clientY;
        const insideItem = x >= itemRect.left && x <= itemRect.right && y >= itemRect.top && y <= itemRect.bottom;
        const insideMenu = x >= menuRect.left && x <= menuRect.right && y >= menuRect.top && y <= menuRect.bottom;
        const insidePanelBridge = x >= menuRect.left && x <= menuRect.right && y >= itemRect.bottom && y <= menuRect.top + 18;

        return insideItem || insideMenu || insidePanelBridge;
      };

      navItems.forEach((item) => {
        item.addEventListener("mouseenter", () => {
          if (desktopHoverQuery.matches) {
            cancelDesktopMenuClose();
            openDesktopMenu(item);
          }
        });

        item.addEventListener("mouseleave", (event) => {
          if (!desktopHoverQuery.matches || isMenuElement(event.relatedTarget)) {
            return;
          }

          scheduleDesktopMenuClose();
        });

        item.querySelector(".nav-trigger")?.addEventListener("focus", () => {
          openDesktopMenu(item);
        });
      });

      header.addEventListener("mousemove", (event) => {
        if (!desktopHoverQuery.matches || !header.querySelector(".primary-nav .nav-item.is-open")) {
          return;
        }

        if (isMenuElement(event.target) || isPointerInOpenMenuPath(event)) {
          cancelDesktopMenuClose();
          return;
        }

        cancelDesktopMenuClose();
        closeAllDesktopMenus();
      });

      document.addEventListener("mousemove", (event) => {
        if (!desktopHoverQuery.matches || !header.querySelector(".primary-nav .nav-item.is-open")) {
          return;
        }

        if (isMenuElement(event.target) || isPointerInOpenMenuPath(event)) {
          cancelDesktopMenuClose();
          return;
        }

        closeAllDesktopMenus();
      }, { passive: true });

      header.addEventListener("mouseleave", closeAllDesktopMenus);
    }

    mobileMenuToggle?.addEventListener("click", () => {
      setMobileMenuOpen(!document.body.classList.contains("mobile-nav-open"));
    });

    mobileNavClose?.addEventListener("click", () => setMobileMenuOpen(false));
    mobileNavOverlay?.addEventListener("click", () => setMobileMenuOpen(false));

    document.querySelectorAll(".mobile-nav-parent").forEach((button) => {
      button.addEventListener("click", () => {
        const panel = button.nextElementSibling;
        const isOpen = button.getAttribute("aria-expanded") === "true";
        button.setAttribute("aria-expanded", String(!isOpen));
        panel?.classList.toggle("is-open", !isOpen);
      });
    });

    document.querySelectorAll("[data-nav-route]").forEach((button) => {
      button.addEventListener("click", () => {
        const href = button.getAttribute("data-nav-route");
        if (href) {
          window.location.href = href;
        }
      });
    });

  };

  const initCartDrawer = () => {
    document.querySelector(".cart-close")?.addEventListener("click", () => setCartDrawerOpen(false));
    document.querySelector(".cart-overlay")?.addEventListener("click", () => setCartDrawerOpen(false));

    const getBundleProperty = (item, key) => item?.properties?.[key] || "";
    const cartBundleNoticeKey = "cartBundleRepairNotice";

    const fetchCart = fetchCartJson;

    const getBundleGroups = (cart) => {
      const groups = new Map();
      (cart?.items || []).forEach((item) => {
        const bundleId = getBundleProperty(item, "_bundle_id");
        if (!bundleId) {
          return;
        }

        if (!groups.has(bundleId)) {
          groups.set(bundleId, []);
        }

        groups.get(bundleId).push(item);
      });

      return groups;
    };

    const getRequiredBundleCount = (items) =>
      items.reduce((requiredCount, item) => {
        const nextCount = Number(getBundleProperty(item, "_bundle_required_count") || getBundleProperty(item, "_bundle_item_count")) || 0;
        return Math.max(requiredCount, nextCount);
      }, 0);

    const isCompleteBundleGroup = (items) => {
      if (!Array.isArray(items) || !items.length) {
        return false;
      }

      const requiredCount = getRequiredBundleCount(items);
      const components = new Set();
      const quantities = new Set();

      items.forEach((item) => {
        const component = getBundleProperty(item, "_bundle_component");
        if (component) {
          components.add(component);
        }
        quantities.add(Number(item.quantity) || 0);
      });

      return (
        requiredCount > 0 &&
        items.length === requiredCount &&
        components.size === requiredCount &&
        quantities.size === 1 &&
        !quantities.has(0)
      );
    };

    const updateCartByKeys = async (updates) => {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ updates })
      });

      if (!response.ok) {
        throw new Error(`Cart update failed: ${response.status}`);
      }

      return response.json();
    };

    const refreshCartDisplay = async ({ openDrawer = true, reloadCartPage = false, refreshCartPage = false } = {}) => {
      if (reloadCartPage && document.body.classList.contains("cart-page")) {
        window.location.reload();
        return;
      }

      const shouldRefreshCartPage = refreshCartPage && document.body.classList.contains("cart-page");
      await refreshSections(["header", "cart-drawer"], "/");
      if (shouldRefreshCartPage) {
        await refreshCartPageContent();
      }
      initCartDrawer();
      if (openDrawer) {
        setCartDrawerOpen(true);
      }
    };

    const removeBundleGroup = async (bundleId, options = {}) => {
      if (!bundleId) {
        return;
      }

      const cart = await fetchCart();
      const bundleItems = getBundleGroups(cart).get(bundleId) || [];
      const updates = {};

      bundleItems.forEach((item) => {
        if (item.key) {
          updates[item.key] = 0;
        }
      });

      if (Object.keys(updates).length) {
        await updateCartByKeys(updates);
      }

      await refreshCartDisplay(options);
    };

    const updateBundleQuantity = async (bundleId, quantity, options = {}) => {
      if (!bundleId) {
        return;
      }

      const nextQuantity = Math.max(0, Number(quantity) || 0);
      const cart = await fetchCart();
      const bundleItems = getBundleGroups(cart).get(bundleId) || [];
      const updates = {};

      bundleItems.forEach((item) => {
        if (item.key) {
          updates[item.key] = nextQuantity;
        }
      });

      if (Object.keys(updates).length) {
        await updateCartByKeys(updates);
      }

      const repairedCart = await removeIncompleteBundleGroups(options);
      if (!repairedCart) {
        await refreshCartDisplay(options);
      }
    };

    const removeIncompleteBundleGroups = async (options = {}) => {
      const cart = await fetchCart();
      const updates = {};
      let removedAnyBundle = false;

      getBundleGroups(cart).forEach((items) => {
        if (isCompleteBundleGroup(items)) {
          return;
        }

        removedAnyBundle = true;
        items.forEach((item) => {
          if (item.key) {
            updates[item.key] = 0;
          }
        });
      });

      if (!removedAnyBundle) {
        return false;
      }

      await updateCartByKeys(updates);
      try {
        window.sessionStorage.setItem(cartBundleNoticeKey, "An incomplete bundle was removed from your bag.");
      } catch (_error) {}
      await refreshCartDisplay(options);
      return true;
    };

    const renderCartBundleNotice = () => {
      let message = "";
      try {
        message = window.sessionStorage.getItem(cartBundleNoticeKey) || "";
        if (message) {
          window.sessionStorage.removeItem(cartBundleNoticeKey);
        }
      } catch (_error) {}

      if (!message) {
        return;
      }

      const noticeTarget = document.querySelector(".cart-body, .cart-page-shell");
      if (!(noticeTarget instanceof HTMLElement)) {
        return;
      }

      const notice = document.createElement("p");
      notice.className = "cart-notice";
      notice.textContent = message;
      noticeTarget.prepend(notice);
    };

    renderCartBundleNotice();

    const updateCartLine = async (lineIndex, quantity, options = {}) => {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          line: Number(lineIndex),
          quantity: Math.max(0, Number(quantity))
        })
      });

      if (!response.ok) {
        throw new Error(`Cart change failed: ${response.status}`);
      }
      const cart = await response.json();

      const refreshOptions = {
        openDrawer: true,
        reloadCartPage: false,
        refreshCartPage: false,
        ...options
      };
      const repairedCart = await removeIncompleteBundleGroups(refreshOptions);
      if (!repairedCart) {
        await refreshCartDisplay(refreshOptions);
      }
      return { cart, repairedCart };
    };

    document.querySelectorAll("[data-upsell-card]").forEach((card) => {
      try {
        if (!(card instanceof HTMLElement) || card.dataset.upsellCardBound === "true") {
          return;
        }
        card.dataset.upsellCardBound = "true";

        const variantScript = card.querySelector("[data-upsell-variants]");
        const addButton = card.querySelector("[data-upsell-add]");
        const priceText = card.querySelector("[data-upsell-price]");
        const errorText = card.querySelector("[data-upsell-error]");
        const optionGroups = Array.from(card.querySelectorAll("[data-upsell-option-group]"));
        const toggleButton = card.querySelector("[data-upsell-toggle]");
        const closeButton = card.querySelector("[data-upsell-close]");
        const picker = card.querySelector("[data-upsell-picker]");
        const upsellImage = card.querySelector("[data-upsell-image]");
        const productLinks = Array.from(card.querySelectorAll("[data-upsell-product-link]"));
        const productUrl = card.getAttribute("data-upsell-product-url") || productLinks[0]?.getAttribute("href")?.split("?")[0] || "";
        const defaultUpsellImage = upsellImage instanceof HTMLImageElement ? {
          src: upsellImage.getAttribute("src") || "",
          srcset: upsellImage.getAttribute("srcset") || "",
          alt: upsellImage.getAttribute("alt") || ""
        } : null;

        const setPickerOpen = (nextOpen) => {
          if (!(picker instanceof HTMLElement)) {
            return;
          }

          picker.hidden = !nextOpen;
          card.classList.toggle("is-expanded", nextOpen);

          if (toggleButton instanceof HTMLButtonElement) {
            toggleButton.setAttribute("aria-expanded", String(nextOpen));
          }
        };

        const updateUpsellProductLinks = (variant) => {
          if (!productLinks.length || !productUrl) {
            return;
          }

          const nextUrl = variant?.id ? `${productUrl}?variant=${encodeURIComponent(String(variant.id))}` : productUrl;
          productLinks.forEach((link) => {
            if (link instanceof HTMLAnchorElement) {
              link.href = nextUrl;
            }
          });
        };

        if (variantScript && addButton && optionGroups.length) {
          let variants = [];
          try {
            variants = JSON.parse(variantScript.textContent || "[]");
          } catch (_error) {}

          const optionMeta = optionGroups.map((group, groupIndex) => ({
            group,
            optionIndex: groupIndex,
            isColour: Boolean(group.querySelector(".colour-choice"))
          }));
          const colourOption = optionMeta.find((meta) => meta.isColour);

          const readSelectedOptions = () =>
            optionGroups.map((group) => {
              const selected = group.querySelector("[aria-pressed='true']");
              return selected ? selected.getAttribute("data-option-value") : null;
            });

          const variantMatchesSelections = (variant, selectedOptions, ignoredIndex = -1) =>
            variant.options.every((value, index) => index === ignoredIndex || !selectedOptions[index] || value === selectedOptions[index]);

          const hasAvailableVariantForOptionValue = (meta, optionValue, selectedOptions) => {
            if (meta.isColour) {
              return variants.some((variant) => variant.available && variant.options[meta.optionIndex] === optionValue);
            }

            return variants.some((variant) => (
              variant.available &&
              variant.options[meta.optionIndex] === optionValue &&
              variantMatchesSelections(variant, selectedOptions, meta.optionIndex)
            ));
          };

          const syncUpsellAvailability = () => {
            const selectedOptions = readSelectedOptions();

            optionMeta.forEach((meta) => {
              meta.group.querySelectorAll("[data-option-value]").forEach((button) => {
                if (!(button instanceof HTMLButtonElement)) {
                  return;
                }

                const optionValue = button.getAttribute("data-option-value") || "";
                const isAvailable = hasAvailableVariantForOptionValue(meta, optionValue, selectedOptions);
                button.disabled = !isAvailable;
                button.setAttribute("aria-disabled", String(!isAvailable));
                button.classList.toggle("is-disabled", !isAvailable);
                button.classList.toggle("is-sold-out", !isAvailable);

                if (!isAvailable) {
                  button.setAttribute("aria-pressed", "false");
                  button.classList.remove("is-selected");
                }
              });
            });
          };

          const updateUpsellImage = (variant) => {
            if (!(upsellImage instanceof HTMLImageElement) || !defaultUpsellImage) {
              return;
            }

            const nextSrc = variant?.featured_media_src || defaultUpsellImage.src;
            const nextSrcset = variant?.featured_media_srcset || defaultUpsellImage.srcset;
            const nextAlt = variant?.featured_media_alt || defaultUpsellImage.alt;

            if (nextSrc) {
              upsellImage.src = nextSrc;
            }
            if (nextSrcset) {
              upsellImage.srcset = nextSrcset;
            } else {
              upsellImage.removeAttribute("srcset");
            }
            if (nextAlt) {
              upsellImage.alt = nextAlt;
            }
            upsellImage.width = 78;
            upsellImage.height = 78;
          };

          const findVariantForUpsellImage = (selectedOptions, matchedVariant) => {
            if (matchedVariant?.featured_media_src) {
              return matchedVariant;
            }

            if (colourOption) {
              const selectedColour = selectedOptions[colourOption.optionIndex];
              if (selectedColour) {
                return variants.find((variant) => (
                  variant.options[colourOption.optionIndex] === selectedColour &&
                  variant.featured_media_src
                )) || null;
              }
            }

            return null;
          };

          const syncUpsellVariant = () => {
            syncUpsellAvailability();
            const selectedOptions = readSelectedOptions();
            const hasIncompleteSelection = selectedOptions.some((value) => !value);
            const matchedVariant = variants.find((variant) =>
              variant.options.every((value, index) => value === selectedOptions[index])
            );
            updateUpsellImage(findVariantForUpsellImage(selectedOptions, matchedVariant));
            updateUpsellProductLinks(matchedVariant);

            if (!matchedVariant) {
              addButton.disabled = true;
              addButton.setAttribute("data-variant-id", "");
              addButton.textContent = "Add to Bag";
              if (errorText) {
                errorText.textContent = hasIncompleteSelection ? "" : "Choose a valid colour and size.";
              }
              return null;
            }

            addButton.disabled = !matchedVariant.available;
            addButton.setAttribute("data-variant-id", String(matchedVariant.id));
            addButton.textContent = matchedVariant.available ? "Add to Bag" : "Sold out";
            if (priceText) {
              priceText.textContent = matchedVariant.price_money;
            }
            if (errorText) {
              errorText.textContent = "";
            }
            return matchedVariant;
          };

          optionGroups.forEach((group) => {
            group.querySelectorAll("[data-option-value]").forEach((button) => {
              button.addEventListener("click", () => {
                if (button.disabled) {
                  return;
                }

                group.querySelectorAll("[data-option-value]").forEach((candidate) => {
                  const isActive = candidate === button;
                  candidate.setAttribute("aria-pressed", String(isActive));
                  candidate.classList.toggle("is-selected", isActive);
                });

                syncUpsellVariant();
              });
            });
          });

          syncUpsellVariant();
        } else if (addButton) {
          updateUpsellProductLinks({ id: addButton.getAttribute("data-variant-id") });
        }

        if (toggleButton instanceof HTMLButtonElement && picker instanceof HTMLElement) {
          toggleButton.addEventListener("click", () => {
            document.querySelectorAll("[data-upsell-card].is-expanded").forEach((openCard) => {
              if (!(openCard instanceof HTMLElement) || openCard === card) {
                return;
              }

              openCard.classList.remove("is-expanded");

              const openPicker = openCard.querySelector("[data-upsell-picker]");
              if (openPicker instanceof HTMLElement) {
                openPicker.hidden = true;
              }

              const openToggle = openCard.querySelector("[data-upsell-toggle]");
              if (openToggle instanceof HTMLButtonElement) {
                openToggle.setAttribute("aria-expanded", "false");
              }
            });

            setPickerOpen(!card.classList.contains("is-expanded"));
          });
        }

        if (closeButton instanceof HTMLButtonElement) {
          closeButton.addEventListener("click", () => {
            setPickerOpen(false);
          });
        }
      } catch (_error) {
        console.error("Upsell card init failed:", _error);
      }
    });

    document.querySelectorAll("[data-upsell-add]").forEach((button) => {
      if (!(button instanceof HTMLButtonElement) || button.dataset.upsellAddBound === "true") {
        return;
      }
      button.dataset.upsellAddBound = "true";

      button.addEventListener("click", async (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (button.disabled || button.dataset.upsellAddPending === "true") {
          return;
        }

        const card = button.closest("[data-upsell-card]");
        if (button === card?.querySelector("[data-upsell-toggle]")) {
          return;
        }

        const variantId = button.getAttribute("data-variant-id");
        if (!variantId) {
          const errorText = card?.querySelector("[data-upsell-error]");
          if (errorText) {
            errorText.textContent = "Select colour and size first.";
          }
          return;
        }

        const errorText = card?.querySelector("[data-upsell-error]");
        const originalLabel = button.textContent;
        button.dataset.upsellAddPending = "true";
        button.disabled = true;
        button.textContent = "Adding...";
        if (errorText) {
          errorText.textContent = "";
        }

        const isCartDrawerUpsell = Boolean(card?.closest(".cart-drawer"));
        const shouldRefreshCartPage = document.body.classList.contains("cart-page");
        const shouldScrollDrawerToItems = isCartDrawerUpsell;
        const sectionNames = ["header", "cart-drawer"];
        const sectionsUrl = window.location.pathname || "/";
        let addSucceeded = false;
        let addFailedResponse = false;
        let payload = null;

        try {
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              id: Number(variantId),
              quantity: 1,
              sections: sectionNames,
              sections_url: sectionsUrl
            })
          });

          if (!response.ok) {
            addFailedResponse = true;
            let addErrorMessage = "We couldn't add it to basket right now.";
            try {
              const errorPayload = await response.json();
              addErrorMessage = errorPayload?.description || errorPayload?.message || addErrorMessage;
            } catch (_jsonError) {
              // Keep the generic add failure message when Shopify returns non-JSON.
            }
            throw new Error(addErrorMessage);
          }

          addSucceeded = true;
          try {
            payload = await response.json();
          } catch (_jsonError) {
            payload = null;
          }

          button.textContent = "Added";
          await new Promise((resolve) => window.setTimeout(resolve, 180));

          if (card instanceof HTMLElement) {
            card.classList.remove("is-expanded");

            const openPicker = card.querySelector("[data-upsell-picker]");
            if (openPicker instanceof HTMLElement) {
              openPicker.hidden = true;
            }

            const openToggle = card.querySelector("[data-upsell-toggle]");
            if (openToggle instanceof HTMLButtonElement) {
              openToggle.setAttribute("aria-expanded", "false");
            }
          }

          try {
            let refreshedSections = [];
            if (payload?.sections) {
              refreshedSections = applySectionPayload(payload.sections, sectionNames);
            }

            const missingSections = sectionNames.filter((sectionName) => !refreshedSections.includes(sectionName));
            if (missingSections.length) {
              const fallbackSections = await refreshSections(missingSections, "/");
              refreshedSections = refreshedSections.concat(fallbackSections);
            }

            if (shouldRefreshCartPage) {
              await refreshCartPageContent();
            }

            initCartDrawer();
          } catch (refreshError) {
            if (!(refreshError instanceof DOMException && refreshError.name === "AbortError")) {
              console.warn("Cart drawer refresh failed after add; falling back to cart JSON.", refreshError);
            }

            try {
              const fallbackCart = await fetchCart();
              syncCartFallbackDisplay(fallbackCart);
            } catch (cartError) {
              console.warn("Cart JSON fallback failed after successful add.", cartError);
            }

            if (shouldRefreshCartPage) {
              window.location.reload();
              return;
            }
          }

          setCartDrawerOpen(true);
          if (shouldScrollDrawerToItems) {
            window.requestAnimationFrame(() => {
              window.requestAnimationFrame(() => {
                scrollCartDrawerToItems();
              });
            });
          }
        } catch (error) {
          if (addFailedResponse && !addSucceeded && errorText) {
            errorText.textContent = error instanceof Error ? error.message : "We couldn't add it to basket right now.";
          }
        } finally {
          if (card instanceof HTMLElement) {
            card.classList.remove("is-expanded");

            const openPicker = card.querySelector("[data-upsell-picker]");
            if (openPicker instanceof HTMLElement) {
              openPicker.hidden = true;
            }

            const openToggle = card.querySelector("[data-upsell-toggle]");
            if (openToggle instanceof HTMLButtonElement) {
              openToggle.setAttribute("aria-expanded", "false");
            }
          }

          delete button.dataset.upsellAddPending;
          button.disabled = false;
          button.textContent = originalLabel;
        }
      });
    });

    document.querySelectorAll("[data-cart-qty]").forEach((button) => {
      button.addEventListener("click", async () => {
        const bundleId = button.getAttribute("data-bundle-id");
        if (bundleId) {
          return;
        }

        const lineIndex = button.getAttribute("data-line-index");
        const nextQuantity = button.getAttribute("data-next-quantity");
        if (!lineIndex || nextQuantity == null) {
          return;
        }

        const qtyControl = button.closest(".qty-control");
        const cartLine = button.closest("[data-cart-line]");
        const quantityText = cartLine?.querySelector("[data-cart-line-quantity]");
        const lineTotalText = cartLine?.querySelector("[data-cart-line-total]");
        const originalLabel = button.textContent;
        const originalQuantityText = quantityText?.textContent || "";
        const originalLineTotalText = lineTotalText?.textContent || "";
        const originalOpacity = cartLine instanceof HTMLElement ? cartLine.style.opacity : "";
        const unitPriceCents = Number(cartLine?.getAttribute("data-original-unit-price-cents") || cartLine?.getAttribute("data-unit-price-cents")) || 0;
        const quantityBreakEligible = cartLine?.getAttribute("data-quantity-break-eligible") !== "false";
        const optimisticQuantity = Math.max(0, Number(nextQuantity));

        qtyControl?.querySelectorAll("button").forEach((candidate) => {
          candidate.disabled = true;
        });
        button.textContent = "…";

        if (quantityText) {
          quantityText.textContent = String(optimisticQuantity);
        }

        if (lineTotalText) {
          lineTotalText.textContent = formatMoney(getQuantityBreakLinePrice(unitPriceCents, optimisticQuantity, quantityBreakEligible));
        }

        if (cartLine instanceof HTMLElement && optimisticQuantity === 0) {
          cartLine.style.opacity = "0.55";
        }

        try {
          await updateCartLine(lineIndex, nextQuantity);
        } catch (_error) {
          if (quantityText) {
            quantityText.textContent = originalQuantityText;
          }
          if (lineTotalText) {
            lineTotalText.textContent = originalLineTotalText;
          }
          if (cartLine instanceof HTMLElement) {
            cartLine.style.opacity = originalOpacity;
          }
          qtyControl?.querySelectorAll("button").forEach((candidate) => {
            candidate.disabled = false;
          });
          button.textContent = originalLabel;
        }
      });
    });

    document.querySelectorAll("[data-cart-bundle-qty]").forEach((button) => {
      button.addEventListener("click", async () => {
        if (button.closest("[data-cart-page-region]")) {
          return;
        }

        const bundleId = button.getAttribute("data-bundle-id");
        const nextQuantity = button.getAttribute("data-next-bundle-quantity");
        if (!bundleId || nextQuantity == null) {
          return;
        }

        const qtyControl = button.closest(".qty-control");
        const originalLabel = button.textContent;

        qtyControl?.querySelectorAll("button").forEach((candidate) => {
          candidate.disabled = true;
        });
        button.textContent = "…";

        try {
          await updateBundleQuantity(bundleId, nextQuantity, {
            openDrawer: true,
            refreshCartPage: false,
            reloadCartPage: false
          });
        } catch (_error) {
          qtyControl?.querySelectorAll("button").forEach((candidate) => {
            candidate.disabled = false;
          });
          button.textContent = originalLabel;
        }
      });
    });

    document.querySelectorAll("[data-cart-remove]").forEach((button) => {
      button.addEventListener("click", async (event) => {
        event.preventDefault();
        if (button.closest("[data-cart-page-region]")) {
          return;
        }

        const bundleId = button.getAttribute("data-bundle-id");
        if (bundleId) {
          return;
        }

        const lineIndex = button.getAttribute("data-line-index");
        if (!lineIndex) {
          return;
        }

        const originalLabel = button.textContent;
        if (button instanceof HTMLButtonElement) {
          button.disabled = true;
        }
        button.textContent = "Removing...";

        try {
          await updateCartLine(lineIndex, 0, {
            openDrawer: true,
            reloadCartPage: false,
            refreshCartPage: false
          });
        } catch (_error) {
          if (button instanceof HTMLButtonElement) {
            button.disabled = false;
          }
          button.textContent = originalLabel;
        }
      });
    });

    document.querySelectorAll("[data-cart-bundle-remove]").forEach((button) => {
      button.addEventListener("click", async () => {
        if (button.closest("[data-cart-page-region]")) {
          return;
        }

        const bundleId = button.getAttribute("data-bundle-id");
        if (!bundleId) {
          return;
        }

        const originalLabel = button.textContent;
        button.disabled = true;
        button.textContent = "Removing bundle...";

        try {
          await removeBundleGroup(bundleId, {
            openDrawer: true,
            refreshCartPage: false,
            reloadCartPage: false
          });
        } catch (_error) {
          button.disabled = false;
          button.textContent = originalLabel;
        }
      });
    });

    const cartPageForm = document.querySelector("[data-cart-page-form]");
    if (cartPageForm instanceof HTMLFormElement) {
      const cartPageRegion = cartPageForm.closest("[data-cart-page-region]");
      const cartPageError = cartPageRegion?.querySelector("[data-cart-page-error]");
      const updateTimers = new Map();
      const freeDeliveryThreshold = 6000;
      let activeCartPageToken = 0;
      let isCartPageUpdating = false;

      if (cartPageForm.dataset.cartPageBound !== "true") {
        cartPageForm.dataset.cartPageBound = "true";

      const setCartPageBusy = (isBusy) => {
        isCartPageUpdating = isBusy;
        if (cartPageRegion instanceof HTMLElement) {
          cartPageRegion.classList.toggle("is-updating", isBusy);
        }

        cartPageForm.querySelectorAll("[data-cart-page-qty-input], [data-cart-page-qty-button], [data-cart-remove], [data-cart-bundle-remove], [data-cart-bundle-qty]").forEach((control) => {
          if (control instanceof HTMLInputElement || control instanceof HTMLButtonElement) {
            control.disabled = isBusy;
          }
        });
      };

      const showCartPageError = (message) => {
        if (!(cartPageError instanceof HTMLElement)) {
          return;
        }

        cartPageError.textContent = message;
        cartPageError.hidden = !message;
      };

      const syncCartPageLineDisplay = (input, quantity) => {
        const cartLine = input.closest("[data-cart-line]");
        const quantityText = cartLine?.querySelector("[data-cart-line-quantity]");
        const lineTotalText = cartLine?.querySelector("[data-cart-line-total]");
        const unitPriceCents = Number(cartLine?.getAttribute("data-original-unit-price-cents") || cartLine?.getAttribute("data-unit-price-cents")) || 0;
        const quantityBreakEligible = cartLine?.getAttribute("data-quantity-break-eligible") !== "false";

        if (quantityText) {
          quantityText.textContent = String(quantity);
        }
        if (lineTotalText) {
          lineTotalText.textContent = formatMoney(getQuantityBreakLinePrice(unitPriceCents, quantity, quantityBreakEligible));
        }
        if (cartLine instanceof HTMLElement) {
          cartLine.classList.toggle("is-updating", true);
          cartLine.style.opacity = quantity === 0 ? "0.55" : "";
        }
      };

      const clearCartPageLineState = (target) => {
        const cartLine = target?.closest?.("[data-cart-line]");
        if (cartLine instanceof HTMLElement) {
          cartLine.classList.remove("is-updating");
          cartLine.style.opacity = "";
        }
      };

      const setText = (selector, text) => {
        document.querySelectorAll(selector).forEach((element) => {
          element.textContent = text;
        });
      };

      const syncHeaderCartCount = (itemCount) => {
        const cartToggle = document.querySelector("[data-cart-toggle]");
        if (!(cartToggle instanceof HTMLElement)) {
          return;
        }

        let badge = cartToggle.querySelector(".cart-badge");
        if (itemCount > 0) {
          if (!(badge instanceof HTMLElement)) {
            badge = document.createElement("span");
            badge.className = "cart-badge";
            cartToggle.append(badge);
          }
          badge.textContent = String(itemCount);
        } else {
          badge?.remove();
        }
      };

      const syncCartPageFromCart = (cart, lineIndex, input) => {
        if (!cart || !Array.isArray(cart.items)) {
          return false;
        }

        const lineNumber = Number(lineIndex);
        const item = cart.items[lineNumber - 1];
        if (!item || Number(item.quantity) <= 0 || Number(cart.item_count) <= 0) {
          return false;
        }

        const cartLine = input.closest("[data-cart-line]");
        const lineTotalText = cartLine?.querySelector("[data-cart-line-total]");
        const quantityBreakEligible = cartLine?.getAttribute("data-quantity-break-eligible") !== "false";
        const unitPriceCents = Number(cartLine?.getAttribute("data-original-unit-price-cents") || item.original_price || item.price || 0);
        const lineTotal = quantityBreakEligible
          ? getQuantityBreakLinePrice(unitPriceCents, item.quantity, true)
          : Number(item.final_line_price ?? item.line_price ?? 0);
        const itemCount = Number(cart.item_count) || 0;
        const totalPrice = cart.items.reduce((sum, cartItem, itemIndex) => {
          const itemLine = document.querySelector(`[data-cart-page-qty-input][data-line-index="${itemIndex + 1}"]`)?.closest("[data-cart-line]");
          const itemEligible = itemLine?.getAttribute("data-quantity-break-eligible") !== "false";
          const itemUnitPrice = Number(itemLine?.getAttribute("data-original-unit-price-cents") || cartItem.original_price || cartItem.price || 0);
          if (!itemEligible) {
            return sum + Number(cartItem.final_line_price ?? cartItem.line_price ?? 0);
          }
          return sum + getQuantityBreakLinePrice(itemUnitPrice, cartItem.quantity, true);
        }, 0);
        const freeDeliveryRemaining = Math.max(0, freeDeliveryThreshold - totalPrice);
        const freeDeliveryProgress = Math.min(100, Math.max(0, Math.round((totalPrice / freeDeliveryThreshold) * 100)));
        const countLabel = `${itemCount} item${itemCount === 1 ? "" : "s"} in your bag.`;

        input.value = String(item.quantity);
        input.setAttribute("data-current-quantity", String(item.quantity));

        if (lineTotalText) {
          lineTotalText.textContent = formatMoney(lineTotal);
        }

        setText("[data-cart-page-count]", countLabel);
        setText("[data-cart-page-subtotal]", formatMoney(totalPrice));
        setText(
          "[data-cart-page-delivery-message]",
          freeDeliveryRemaining > 0 ? `You're ${formatMoney(freeDeliveryRemaining)} away from free UK delivery` : "You've unlocked free UK delivery!"
        );
        document.querySelectorAll("[data-cart-page-delivery-bar]").forEach((bar) => {
          if (bar instanceof HTMLElement) {
            bar.style.width = `${freeDeliveryProgress}%`;
          }
        });

        document.querySelectorAll("[data-cart-page-bundle-total]").forEach((bundleTotal) => {
          const savings = Number(document.querySelector("[data-cart-page-bundle-savings]")?.getAttribute("data-bundle-discount-cents")) || 0;
          bundleTotal.textContent = formatMoney(Math.max(0, totalPrice - savings));
        });

        syncHeaderCartCount(itemCount);
        return true;
      };

      const runCartPageUpdate = async (operation, { restore, target } = {}) => {
        if (isCartPageUpdating) {
          return null;
        }

        const token = activeCartPageToken + 1;
        activeCartPageToken = token;
        showCartPageError("");
        setCartPageBusy(true);

        let result = null;
        try {
          result = await operation();
        } catch (_error) {
          if (activeCartPageToken === token) {
            restore?.();
            showCartPageError("We couldn't update your bag just now. Please try again.");
          }
        } finally {
          if (activeCartPageToken === token && cartPageRegion instanceof HTMLElement && cartPageRegion.isConnected) {
            clearCartPageLineState(target);
            setCartPageBusy(false);
          }
        }
        return result;
      };

      const commitCartPageQuantity = async (input, quantity) => {
        const lineIndex = input.getAttribute("data-line-index");
        if (!lineIndex) {
          return;
        }
        if (isCartPageUpdating) {
          return;
        }

        const nextQuantity = Math.max(0, Number(quantity) || 0);
        const previousQuantity = Math.max(0, Number(input.getAttribute("data-current-quantity") || input.defaultValue || input.value) || 0);
        const cartLine = input.closest("[data-cart-line]");
        const lineTotalText = cartLine?.querySelector("[data-cart-line-total]");
        const previousLineTotal = lineTotalText?.textContent || "";

        window.clearTimeout(updateTimers.get(input));
        updateTimers.delete(input);
        input.value = String(nextQuantity);
        syncCartPageLineDisplay(input, nextQuantity);

        const shouldRefreshCartPage = true;
        const result = await runCartPageUpdate(() => updateCartLine(lineIndex, nextQuantity, {
            openDrawer: false,
            reloadCartPage: false,
            refreshCartPage: shouldRefreshCartPage
          }), {
          target: input,
          restore: () => {
          input.value = String(previousQuantity);
          input.setAttribute("data-current-quantity", String(previousQuantity));
          syncCartPageLineDisplay(input, previousQuantity);
          if (lineTotalText) {
            lineTotalText.textContent = previousLineTotal;
          }
          if (cartLine instanceof HTMLElement) {
            cartLine.classList.remove("is-updating");
            cartLine.style.opacity = "";
          }
          }
        });

        if (!shouldRefreshCartPage && result?.repairedCart) {
          await refreshCartDisplay({ openDrawer: false, reloadCartPage: false, refreshCartPage: true });
          return;
        }

        if (!shouldRefreshCartPage && result?.cart && !syncCartPageFromCart(result.cart, lineIndex, input)) {
          await refreshCartDisplay({ openDrawer: false, reloadCartPage: false, refreshCartPage: true });
        }
      };

      cartPageForm.addEventListener("click", (event) => {
        const target = event.target;
        if (!(target instanceof Element)) {
          return;
        }
        if (isCartPageUpdating && target.closest("[data-cart-page-qty-button], [data-cart-bundle-qty], [data-cart-remove], [data-cart-bundle-remove]")) {
          event.preventDefault();
          return;
        }

        const quantityButton = target.closest("[data-cart-page-qty-button]");
        if (quantityButton instanceof HTMLButtonElement) {
          event.preventDefault();
          const lineIndex = quantityButton.getAttribute("data-line-index");
          const input = lineIndex ? Array.from(cartPageForm.querySelectorAll("[data-cart-page-qty-input]")).find((candidate) => (
            candidate instanceof HTMLInputElement &&
            candidate.getAttribute("data-line-index") === lineIndex
          )) : null;
          if (!(input instanceof HTMLInputElement)) {
            return;
          }

          const delta = Number(quantityButton.getAttribute("data-quantity-delta")) || 0;
          const currentQuantity = Math.max(0, Number(input.value) || 0);
          commitCartPageQuantity(input, currentQuantity + delta);
          return;
        }

        const bundleQuantityButton = target.closest("[data-cart-bundle-qty]");
        if (bundleQuantityButton instanceof HTMLButtonElement) {
          event.preventDefault();
          const bundleId = bundleQuantityButton.getAttribute("data-bundle-id");
          const nextQuantity = bundleQuantityButton.getAttribute("data-next-bundle-quantity");
          if (!bundleId || nextQuantity == null) {
            return;
          }

          bundleQuantityButton.textContent = "...";
          runCartPageUpdate(() => updateBundleQuantity(bundleId, nextQuantity, {
            openDrawer: false,
            reloadCartPage: false,
            refreshCartPage: true
          }), { target: bundleQuantityButton });
          return;
        }

        const removeButton = target.closest("[data-cart-remove]");
        if (removeButton instanceof HTMLButtonElement) {
          event.preventDefault();
          const lineIndex = removeButton.getAttribute("data-line-index");
          if (!lineIndex) {
            return;
          }

          removeButton.textContent = "Removing...";
          runCartPageUpdate(() => updateCartLine(lineIndex, 0, {
            openDrawer: false,
            reloadCartPage: false,
            refreshCartPage: true
          }), { target: removeButton });
          return;
        }

        const bundleRemoveButton = target.closest("[data-cart-bundle-remove]");
        if (bundleRemoveButton instanceof HTMLButtonElement) {
          event.preventDefault();
          const bundleId = bundleRemoveButton.getAttribute("data-bundle-id");
          if (!bundleId) {
            return;
          }

          bundleRemoveButton.textContent = "Removing bundle...";
          runCartPageUpdate(() => removeBundleGroup(bundleId, {
            openDrawer: false,
            reloadCartPage: false,
            refreshCartPage: true
          }), { target: bundleRemoveButton });
        }
      });

      cartPageForm.addEventListener("input", (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || !input.matches("[data-cart-page-qty-input]")) {
          return;
        }

        if (input.value === "") {
          return;
        }

        const nextQuantity = Math.max(0, Number(input.value) || 0);
        window.clearTimeout(updateTimers.get(input));
        updateTimers.set(input, window.setTimeout(() => {
          commitCartPageQuantity(input, nextQuantity);
        }, 400));
      });

      cartPageForm.addEventListener("change", (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || !input.matches("[data-cart-page-qty-input]")) {
          return;
        }

        const nextQuantity = Math.max(0, Number(input.value) || 0);
        commitCartPageQuantity(input, nextQuantity);
      });

      cartPageForm.addEventListener("submit", (event) => {
        event.preventDefault();
        const changedInput = Array.from(cartPageForm.querySelectorAll("[data-cart-page-qty-input]")).find((input) => (
          input instanceof HTMLInputElement &&
          Number(input.value) !== Number(input.getAttribute("data-current-quantity") || input.defaultValue || input.value)
        ));

        if (changedInput instanceof HTMLInputElement) {
          commitCartPageQuantity(changedInput, changedInput.value);
        }
      });
      }
    }

    document.querySelectorAll(".cart-checkout, button[name='checkout']").forEach((checkoutControl) => {
      checkoutControl.addEventListener("click", async (event) => {
        event.preventDefault();

        const repairedCart = await removeIncompleteBundleGroups({
          openDrawer: true,
          reloadCartPage: document.body.classList.contains("cart-page")
        });

        if (repairedCart) {
          return;
        }

        if (checkoutControl instanceof HTMLAnchorElement) {
          window.location.href = checkoutControl.href;
          return;
        }

        window.location.href = "/checkout";
      });
    });

    document.querySelectorAll("form[action='/cart'], form[action='/cart/']").forEach((form) => {
      form.addEventListener("submit", async (event) => {
        const submitter = event.submitter;
        const isCheckout = submitter instanceof HTMLElement && submitter.getAttribute("name") === "checkout";
        if (!isCheckout) {
          return;
        }

        event.preventDefault();
        const repairedCart = await removeIncompleteBundleGroups({
          openDrawer: true,
          reloadCartPage: true
        });

        if (!repairedCart) {
          window.location.href = "/checkout";
        }
      });
    });
  };

  const initNewsletter = () => {
    document.querySelectorAll(".newsletter-form").forEach((form) => {
      if (form.dataset.newsletterBound === "true") {
        return;
      }

      const button = form.querySelector("[data-newsletter-submit]");

      if (!(button instanceof HTMLButtonElement)) {
        return;
      }

      form.dataset.newsletterBound = "true";

      form.addEventListener("submit", (event) => {
        if (!form.reportValidity()) {
          event.preventDefault();
          return;
        }

        const section = form.closest("[data-newsletter-section]");

        try {
          window.sessionStorage.setItem(newsletterScrollKey, String(window.scrollY));
          window.sessionStorage.setItem(newsletterStateKey, "pending");
        } catch (_error) {}

        section?.classList.add("is-submitting");
        button.disabled = true;
        button.textContent = "Submitting...";
      });
    });

    let storedScrollY = null;
    let storedNewsletterState = null;
    try {
      storedScrollY = window.sessionStorage.getItem(newsletterScrollKey);
      storedNewsletterState = window.sessionStorage.getItem(newsletterStateKey);
    } catch (_error) {}

    if (storedScrollY !== null || storedNewsletterState !== null) {
      const nextScrollY = Number.parseInt(storedScrollY, 10);

      try {
        window.sessionStorage.removeItem(newsletterScrollKey);
        window.sessionStorage.removeItem(newsletterStateKey);
      } catch (_error) {}

      if (window.location.hash === "#contact_form") {
        window.history.replaceState({}, document.title, `${window.location.pathname}${window.location.search}`);
      }

      if (Number.isFinite(nextScrollY)) {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            window.scrollTo({ top: nextScrollY, left: 0, behavior: "auto" });
          });
        });
      }

      const newsletterSection = document.querySelector("[data-newsletter-section]");
      const successMessage = document.querySelector('[id^="newsletter-success-"]');
      const errorMessage = document.querySelector('[id^="newsletter-error-"]');
      const emailInput = document.querySelector('.newsletter-form input[name="contact[email]"]');

      if (newsletterSection instanceof HTMLElement) {
        newsletterSection.classList.add("is-returned");

        if (successMessage instanceof HTMLElement) {
          newsletterSection.classList.add("is-success");
        } else if (errorMessage instanceof HTMLElement) {
          newsletterSection.classList.add("is-error");
        }

        window.setTimeout(() => {
          newsletterSection.classList.remove("is-returned");
        }, 1400);
      }

      if (successMessage instanceof HTMLElement) {
        successMessage.focus({ preventScroll: true });
      } else if (errorMessage instanceof HTMLElement) {
        errorMessage.focus({ preventScroll: true });
        emailInput?.focus({ preventScroll: true });
      }
    }
  };

  const initContactForms = () => {
    if (document.body.dataset.contactHandlerBound === "true") {
      return;
    }

    document.body.dataset.contactHandlerBound = "true";

    document.querySelectorAll(".js-contact-form").forEach((form) => {
      if (!(form instanceof HTMLFormElement) || form.dataset.contactBound === "true") {
        return;
      }

      const submitButton = form.querySelector("[data-contact-submit]");

      form.dataset.contactBound = "true";
      form.removeAttribute("target");

      if (!(submitButton instanceof HTMLButtonElement)) {
        return;
      }

      form.addEventListener("submit", (event) => {
        if (!form.reportValidity()) {
          event.preventDefault();
          return;
        }

        submitButton.disabled = true;
        submitButton.textContent = "Sending...";
      });
    });
  };

  const initSearch = () => {
    const searchPanel = document.querySelector(".search-panel");
    const searchForm = document.querySelector(".search-form");
    const searchInput = document.querySelector(".search-form input[name='q']");
    const searchClear = document.querySelector(".search-clear");
    const searchSuggestions = document.querySelector(".search-suggestions");
    const searchResults = document.querySelector(".search-results");
    const searchEmpty = document.querySelector("[data-search-empty]");
    const searchEmptyTitle = document.querySelector("[data-search-empty-title]");
    const productsList = document.querySelector("[data-search-product-list]");
    const predictiveSearchUrl = searchPanel?.getAttribute("data-predictive-search-url");

    if (!searchInput || !searchForm) {
      return;
    }

    let requestId = 0;
    let debounceTimer = null;
    let activeQuery = "";
    let currentResultsKey = "";
    const searchResultCache = new Map();
    const loadedSearchImages = new Set();
    const preloadTimeout = 280;

    const moneyFormatter = new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "GBP"
    });

    const escapeHtml = (value = "") =>
      String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");

    const getProductRatingSkuString = (product) => {
      const variants = Array.isArray(product?.variants) ? product.variants : [];
      const skus = variants
        .map((variant) => String(variant?.sku || "").trim())
        .filter(Boolean);

      return skus.length ? `${skus.join(";")};` : "";
    };

    const getSearchImageUrl = (src, width) => {
      if (!src || !width) {
        return "";
      }

      try {
        const imageUrl = new URL(src, window.location.origin);
        imageUrl.searchParams.set("width", String(width));
        return imageUrl.toString();
      } catch (_error) {
        const separator = src.includes("?") ? "&" : "?";
        return `${src}${separator}width=${width}`;
      }
    };

    const preloadSearchImage = (src) => {
      if (!src || loadedSearchImages.has(src)) {
        return Promise.resolve();
      }

      return new Promise((resolve) => {
        const image = new Image();
        let isSettled = false;

        const finish = (didLoad = false) => {
          if (isSettled) return;
          isSettled = true;
          if (didLoad) {
            loadedSearchImages.add(src);
          }
          resolve();
        };

        image.onload = () => finish(true);
        image.onerror = () => finish(false);
        image.decoding = "async";
        if ("fetchPriority" in image) {
          image.fetchPriority = "high";
        }
        image.src = src;
      });
    };

    const preloadVisibleSearchImages = async (products = []) => {
      const visibleImageUrls = products
        .slice(0, 4)
        .map((product) => product.featured_image?.url || product.image?.url || "")
        .map((src) => getSearchImageUrl(src, 160))
        .filter(Boolean);

      if (!visibleImageUrls.length) {
        return;
      }

      await Promise.race([
        Promise.all(visibleImageUrls.map(preloadSearchImage)),
        new Promise((resolve) => window.setTimeout(resolve, preloadTimeout))
      ]);
    };

    const hydrateSearchImages = () => {
      productsList?.querySelectorAll("[data-search-result-image]").forEach((image) => {
        const markLoaded = () => {
          image.classList.add("is-loaded");
          if (image.currentSrc) loadedSearchImages.add(image.currentSrc);
          if (image.src) loadedSearchImages.add(image.src);
        };

        if (image.complete && image.naturalWidth > 0) {
          markLoaded();
          return;
        }

        image.addEventListener("load", markLoaded, { once: true });
        image.addEventListener("error", () => image.closest(".search-result-card")?.classList.add("has-image-error"), { once: true });
      });
    };

    const renderProductResult = (product, index = 0) => {
      const imageSrc = product.featured_image?.url || product.image?.url || "";
      const imageAlt = product.featured_image?.alt || product.image?.alt || product.title || "";
      const thumb80 = getSearchImageUrl(imageSrc, 80);
      const thumb160 = getSearchImageUrl(imageSrc, 160);
      const thumb240 = getSearchImageUrl(imageSrc, 240);
      const isPriorityImage = index < 4;
      const imageIsLoaded = loadedSearchImages.has(thumb160) || loadedSearchImages.has(imageSrc);
      const price = typeof product.price === "number" ? moneyFormatter.format(product.price / 100) : "";
      const compareAt = typeof product.compare_at_price === "number" && product.compare_at_price > product.price
        ? moneyFormatter.format(product.compare_at_price / 100)
        : "";
      const ratingSkus = getProductRatingSkuString(product);

      return `
        <a class="search-result-card" href="${product.url}">
          ${imageSrc ? `<img
            class="search-result-image${imageIsLoaded ? " is-loaded" : ""}"
            data-search-result-image
            src="${escapeHtml(thumb160 || imageSrc)}"
            srcset="${escapeHtml(thumb80)} 80w, ${escapeHtml(thumb160)} 160w, ${escapeHtml(thumb240)} 240w"
            sizes="(max-width: 560px) 44px, 66px"
            alt="${escapeHtml(imageAlt)}"
            width="80"
            height="100"
            loading="${isPriorityImage ? "eager" : "lazy"}"
            ${isPriorityImage ? 'fetchpriority="high"' : ""}
            decoding="async"
          >` : `<span class="search-result-placeholder" aria-hidden="true"></span>`}
          <div>
            <strong>${escapeHtml(product.title)}</strong>
            <small>${compareAt ? `<s>${compareAt}</s> ` : ""}${price}</small>
            ${ratingSkus ? `<div class="product-rating product-rating--snippet search-card-rating"><div class="ruk_rating_snippet" data-sku="${escapeHtml(ratingSkus)}"></div></div>` : ""}
          </div>
        </a>
      `;
    };

    const syncSearchClear = () => {
      if (searchClear) {
        searchClear.hidden = !searchInput.value;
      }
    };

    const clearResults = () => {
      if (productsList) productsList.innerHTML = "";
      currentResultsKey = "";
    };

    const showSuggestionState = () => {
      searchSuggestions?.removeAttribute("hidden");
      searchResults?.setAttribute("hidden", "");
      searchResults?.classList.remove("is-query-active");
      searchEmpty?.setAttribute("hidden", "");
      clearResults();
    };

    const showEmptyState = (query) => {
      searchSuggestions?.setAttribute("hidden", "");
      searchResults?.setAttribute("hidden", "");
      searchResults?.classList.remove("is-query-active");
      searchEmpty?.removeAttribute("hidden");
      clearResults();
      if (searchEmptyTitle) {
        searchEmptyTitle.textContent = `No matches for "${query}"`;
      }
    };

    const showResultState = (products = [], query = "") => {
      searchSuggestions?.setAttribute("hidden", "");
      searchEmpty?.setAttribute("hidden", "");
      searchResults?.removeAttribute("hidden");
      searchResults?.classList.add("is-query-active");

      if (productsList) {
        const nextResultsKey = `${query}:${products.map((product) => product.id || product.url).join("|")}`;
        if (nextResultsKey && nextResultsKey === currentResultsKey) {
          hydrateSearchImages();
          return;
        }

        productsList.innerHTML = products.map(renderProductResult).join("");
        currentResultsKey = nextResultsKey;
        hydrateSearchImages();
        initReviewsIoRatingSnippets(productsList);
      }
    };

    const fetchPredictiveResults = async (query, currentRequestId) => {
      if (!predictiveSearchUrl) {
        showEmptyState(query);
        return;
      }

      const cacheKey = query.toLowerCase();
      if (searchResultCache.has(cacheKey)) {
        const cachedProducts = searchResultCache.get(cacheKey);
        if (cachedProducts.length) {
          preloadVisibleSearchImages(cachedProducts).catch(() => undefined);
          if (currentRequestId === requestId) {
            showResultState(cachedProducts, cacheKey);
          }
          return;
        }
      }

      const endpoint = `${predictiveSearchUrl}?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide`;
      const response = await fetch(endpoint, {
        headers: {
          Accept: "application/json"
        }
      });

      if (!response.ok) {
        throw new Error(`Predictive search failed: ${response.status}`);
      }

      const payload = await response.json();
      if (currentRequestId !== requestId) {
        return;
      }

      const results = payload.resources?.results || {};
      const products = Array.isArray(results.products) ? results.products : [];

      if (!products.length) {
        showEmptyState(query);
        return;
      }

      searchResultCache.set(query.toLowerCase(), products);
      preloadVisibleSearchImages(products).catch(() => undefined);

      if (currentRequestId !== requestId) {
        return;
      }

      showResultState(products, query.toLowerCase());
    };

    const runLiveSearch = () => {
      const query = searchInput.value.trim();
      syncSearchClear();

      if (!query) {
        requestId += 1;
        window.clearTimeout(debounceTimer);
        showSuggestionState();
        return;
      }

      requestId += 1;
      const currentRequestId = requestId;
      activeQuery = query.toLowerCase();

      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(async () => {
        try {
          if (searchResultCache.has(activeQuery)) {
            const cachedProducts = searchResultCache.get(activeQuery);
            preloadVisibleSearchImages(cachedProducts).catch(() => undefined);
            if (currentRequestId === requestId) {
              showResultState(cachedProducts, activeQuery);
            }
            return;
          }

          await fetchPredictiveResults(query, currentRequestId);
        } catch (_error) {
          showEmptyState(query);
        }
      }, 180);
    };

    syncSearchClear();
    showSuggestionState();

    searchInput.addEventListener("input", runLiveSearch);

    searchForm.addEventListener("submit", (event) => {
      event.preventDefault();
      if (!searchInput.value.trim()) return;
      runLiveSearch();
    });

    searchClear?.addEventListener("click", () => {
      searchInput.value = "";
      runLiveSearch();
      searchInput.focus();
    });

  };

  const initProductGallery = () => {
    document.querySelectorAll("[data-product-gallery]").forEach((gallery) => {
      if (gallery.dataset.galleryBound === "true") {
        return;
      }

      const mainImage = gallery.querySelector("[data-main-image]");
      const bufferImage = gallery.querySelector("[data-buffer-image]");
      const mainImageShell = gallery.querySelector("[data-main-image-shell]");
      const mobileScrollGallery = gallery.querySelector(".pdp-mobile-scroll-gallery");
      const lightbox = gallery.querySelector("[data-gallery-lightbox]");
      const lightboxImage = lightbox?.querySelector("[data-lightbox-image]");

      if (!(mainImage instanceof HTMLImageElement) || !(bufferImage instanceof HTMLImageElement)) {
        return;
      }

      const getThumbButtons = () => Array.from(gallery.querySelectorAll("[data-media-trigger]"));
      const getDotButtons = () => Array.from(gallery.querySelectorAll("[data-dot-trigger]"));
      const getMobileSlides = () => Array.from(gallery.querySelectorAll(".pdp-mobile-scroll-slide"));
      const getFallbackSlide = () => ({
        index: 0,
        src: mainImage.getAttribute("data-fallback-src") || mainImage.getAttribute("src") || mainImage.src || "",
        srcset: mainImage.getAttribute("data-fallback-srcset") || mainImage.getAttribute("srcset") || "",
        sizes: mainImage.getAttribute("data-fallback-sizes") || mainImage.getAttribute("sizes") || "",
        alt: mainImage.getAttribute("data-fallback-alt") || mainImage.alt || "",
        lightboxSrc: mainImage.getAttribute("data-fallback-src") || mainImage.getAttribute("src") || mainImage.src || "",
        lightboxSrcset: mainImage.getAttribute("data-fallback-srcset") || mainImage.getAttribute("srcset") || "",
        lightboxSizes: mainImage.getAttribute("data-fallback-sizes") || mainImage.getAttribute("sizes") || ""
      });
      const getSlides = () => {
        const thumbSlides = getThumbButtons().map((button, index) => ({
          button,
          index,
          src: button.getAttribute("data-image-src") || "",
          srcset: button.getAttribute("data-image-srcset") || "",
          sizes: button.getAttribute("data-image-sizes") || "",
          alt: button.getAttribute("data-image-alt") || mainImage.alt,
          lightboxSrc: button.getAttribute("data-lightbox-src") || button.getAttribute("data-image-src") || "",
          lightboxSrcset: button.getAttribute("data-lightbox-srcset") || button.getAttribute("data-image-srcset") || "",
          lightboxSizes: button.getAttribute("data-lightbox-sizes") || button.getAttribute("data-image-sizes") || ""
        }));
        return thumbSlides.length ? thumbSlides : [getFallbackSlide()];
      };

      const restoreMainImageFallback = () => {
        const fallbackSlide = getFallbackSlide();
        if (!fallbackSlide.src) {
          return false;
        }

        const hasCurrentSource = Boolean(mainImage.currentSrc || mainImage.getAttribute("src") || mainImage.src);
        const hasFailedSource = mainImage.complete && mainImage.naturalWidth <= 0;
        if (hasCurrentSource && !hasFailedSource) {
          return false;
        }

        setImageSource(mainImage, fallbackSlide.src, fallbackSlide.alt, fallbackSlide.srcset, fallbackSlide.sizes);
        if (bufferImage instanceof HTMLImageElement) {
          setImageSource(bufferImage, fallbackSlide.src, fallbackSlide.alt, fallbackSlide.srcset, fallbackSlide.sizes);
        }
        return true;
      };

      const loadedSlideSrcs = new Set();
      const preloadingSlideSrcs = new Map();
      const loadedLightboxSrcs = new Set();
      const markSlideLoaded = (slide, image) => {
        if (slide?.src) {
          loadedSlideSrcs.add(slide.src);
        }
        if (image?.currentSrc) {
          loadedSlideSrcs.add(image.currentSrc);
        }
      };
      const preloadSlide = (slide, priority = "low") => {
        if (!slide?.src) {
          return Promise.reject(new Error("Missing gallery image source"));
        }

        if (loadedSlideSrcs.has(slide.src)) {
          return Promise.resolve();
        }

        const activePreload = preloadingSlideSrcs.get(slide.src);
        if (activePreload) {
          return activePreload;
        }

        const preload = new Promise((resolve, reject) => {
          const img = new Image();
          let settled = false;
          const settle = (isLoaded) => {
            if (settled) {
              return;
            }
            settled = true;
            window.clearTimeout(timeout);
            img.onload = null;
            img.onerror = null;

            if (!isLoaded || img.naturalWidth <= 0) {
              reject(new Error("Gallery image failed to load"));
              return;
            }

            markSlideLoaded(slide, img);
            if (typeof img.decode === "function") {
              img.decode().catch(() => undefined);
            }
            resolve();
          };
          const timeout = window.setTimeout(() => settle(false), 6000);

          if ("fetchPriority" in img) {
            img.fetchPriority = priority;
          }
          img.decoding = "async";
          if (slide.sizes) {
            img.sizes = slide.sizes;
          }
          if (slide.srcset) {
            img.srcset = slide.srcset;
          }
          img.onload = () => settle(true);
          img.onerror = () => settle(false);
          img.src = slide.src;

          if (img.complete) {
            settle(img.naturalWidth > 0);
          }
        }).finally(() => {
          preloadingSlideSrcs.delete(slide.src);
        });

        preloadingSlideSrcs.set(slide.src, preload);
        return preload;
      };

      const prefetchSlide = (slide, priority = "low") => {
        if (!slide?.src || loadedSlideSrcs.has(slide.src)) {
          return;
        }
        preloadSlide(slide, priority).catch(() => undefined);
      };
      const prefetchSlideAt = (index, priority = "low") => {
        const slide = getSlides()[index];
        if (slide) {
          prefetchSlide(slide, priority);
        }
      };
      const prefetchNearbySlides = (centerIndex, priority = "low") => {
        const slides = getSlides();
        [centerIndex + 1, centerIndex + 2, centerIndex - 1].forEach((slideIndex) => {
          if (slides[slideIndex]) {
            prefetchSlide(slides[slideIndex], priority);
          }
        });
      };
      const scheduleNearbySlidePreload = (centerIndex = activeIndex) => {
        const run = () => prefetchNearbySlides(centerIndex, "low");
        if ("requestIdleCallback" in window) {
          window.requestIdleCallback(run, { timeout: 1200 });
          return;
        }
        window.setTimeout(run, 180);
      };

      const preloadLightboxSlide = (slide) => new Promise((resolve, reject) => {
        if (!slide?.lightboxSrc) {
          reject(new Error("Missing lightbox image source"));
          return;
        }

        if (loadedLightboxSrcs.has(slide.lightboxSrc)) {
          resolve();
          return;
        }

        const img = new Image();
        let settled = false;
        const settle = (isLoaded) => {
          if (settled) {
            return;
          }
          settled = true;
          window.clearTimeout(timeout);
          img.onload = null;
          img.onerror = null;

          if (!isLoaded || img.naturalWidth <= 0) {
            reject(new Error("Lightbox image failed to load"));
            return;
          }

          const decode = typeof img.decode === "function" ? img.decode() : Promise.resolve();
          const decodeTimeout = new Promise((resolveTimeout) => window.setTimeout(resolveTimeout, 350));
          Promise.race([decode.catch(() => undefined), decodeTimeout]).then(() => {
            loadedLightboxSrcs.add(slide.lightboxSrc);
            resolve();
          });
        };
        const timeout = window.setTimeout(() => settle(false), 6000);

        if ("fetchPriority" in img) {
          img.fetchPriority = "high";
        }
        img.decoding = "async";
        if (slide.lightboxSizes) {
          img.sizes = slide.lightboxSizes;
        }
        if (slide.lightboxSrcset) {
          img.srcset = slide.lightboxSrcset;
        }
        img.onload = () => settle(true);
        img.onerror = () => settle(false);
        img.src = slide.lightboxSrc;

        if (img.complete) {
          settle(img.naturalWidth > 0);
        }
      });

      const prefetchLightboxSlide = (slide) => {
        if (!slide?.lightboxSrc || loadedLightboxSrcs.has(slide.lightboxSrc)) {
          return;
        }
        preloadLightboxSlide(slide).catch(() => undefined);
      };

      const prefetchAdjacentLightboxSlides = (index) => {
        const slides = getSlides();
        [index - 1, index + 1].forEach((slideIndex) => {
          if (slides[slideIndex]) {
            prefetchLightboxSlide(slides[slideIndex]);
          }
        });
      };

      let activeIndex = Math.max(0, getThumbButtons().findIndex((button) => button.classList.contains("is-active")));
      let selectedIndex = activeIndex;
      let isAnimating = false;
      let activeFinish = null;
      let switchToken = 0;
      let lightboxIndex = activeIndex;
      let lightboxSwitchToken = 0;
      let mobileScrollFrame = 0;
      let mobileSettleFrame = 0;
      let isMobileSettling = false;
      const isMobileGallery = () => window.matchMedia("(max-width: 820px)").matches;
      const prefersReducedGalleryMotion = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      const initialSlide = getSlides()[activeIndex];
      markSlideLoaded(initialSlide, mainImage);

      const syncActiveControls = () => {
        getThumbButtons().forEach((button, index) => {
          const isSelected = index === selectedIndex;
          button.classList.toggle("is-active", isSelected);
          button.toggleAttribute("aria-current", isSelected);
          button.setAttribute("aria-selected", String(isSelected));
          button.tabIndex = isSelected ? 0 : -1;
        });
        getDotButtons().forEach((button, index) => {
          const isSelected = index === selectedIndex;
          button.classList.toggle("is-active", isSelected);
          button.toggleAttribute("aria-current", isSelected);
          button.setAttribute("aria-selected", String(isSelected));
        });
        gallery.dataset.activeMediaIndex = String(selectedIndex);
      };

      const selectControlsIndex = (nextIndex) => {
        const slides = getSlides();
        if (nextIndex < 0 || nextIndex >= slides.length) {
          return false;
        }
        selectedIndex = nextIndex;
        syncActiveControls();
        return true;
      };

      const getNearestMobileSlideIndex = () => {
        if (!(mobileScrollGallery instanceof HTMLElement)) {
          return -1;
        }

        const mobileSlides = getMobileSlides();
        if (!mobileSlides.length) {
          return -1;
        }

        const slideWidth = mobileScrollGallery.clientWidth || mobileSlides[0]?.clientWidth || 1;
        return Math.max(0, Math.min(mobileSlides.length - 1, Math.round(mobileScrollGallery.scrollLeft / slideWidth)));
      };

      const scrollMobileGalleryToIndex = (nextIndex, behavior = "smooth") => {
        if (!(mobileScrollGallery instanceof HTMLElement)) {
          return false;
        }

        const mobileSlide = getMobileSlides()[nextIndex];
        if (!(mobileSlide instanceof HTMLElement)) {
          return false;
        }

        const slideWidth = mobileScrollGallery.clientWidth || mobileSlide.clientWidth || 1;
        const targetLeft = slideWidth * nextIndex;
        if (behavior === "settle" && !prefersReducedGalleryMotion()) {
          if (mobileSettleFrame) {
            window.cancelAnimationFrame(mobileSettleFrame);
            mobileSettleFrame = 0;
          }
          isMobileSettling = false;

          const startLeft = mobileScrollGallery.scrollLeft;
          const distance = targetLeft - startLeft;
          const duration = Math.min(185, Math.max(120, Math.abs(distance) * 0.3));
          const startedAt = performance.now();
          const slides = getSlides();
          const easeOut = (progress) => 1 - Math.pow(1 - progress, 3);

          activeIndex = nextIndex;
          selectedIndex = nextIndex;
          syncActiveControls();
          scheduleNearbySlidePreload(activeIndex);
          updateLightboxImage(slides[activeIndex]);
          mobileScrollGallery.classList.add("is-settling");
          isMobileSettling = true;

          const step = (timestamp) => {
            const progress = Math.min(1, (timestamp - startedAt) / duration);
            mobileScrollGallery.scrollLeft = startLeft + distance * easeOut(progress);
            if (progress < 1) {
              mobileSettleFrame = window.requestAnimationFrame(step);
              return;
            }

            mobileScrollGallery.scrollLeft = targetLeft;
            mobileSettleFrame = 0;
            isMobileSettling = false;
            mobileScrollGallery.classList.remove("is-settling");
          };

          mobileSettleFrame = window.requestAnimationFrame(step);
          return true;
        }

        const scrollBehavior = behavior === "smooth" && !prefersReducedGalleryMotion() ? "smooth" : "auto";
        mobileScrollGallery.scrollTo({ left: targetLeft, behavior: scrollBehavior });
        return true;
      };

      const setImageSource = (image, src, alt, srcset, sizes) => {
        if (!(image instanceof HTMLImageElement) || !src) {
          return;
        }

        if (sizes) {
          image.sizes = sizes;
        } else {
          image.removeAttribute("sizes");
        }
        if (srcset) {
          image.srcset = srcset;
        } else {
          image.removeAttribute("srcset");
        }
        image.src = src;
        image.alt = alt || image.alt;
      };
      restoreMainImageFallback();

      const afterImageReady = (image, callback) => {
        if (!(image instanceof HTMLImageElement)) {
          callback(false);
          return;
        }

        if (image.complete && image.naturalWidth > 0) {
          requestAnimationFrame(() => callback(true));
          return;
        }

        let settled = false;
        const settle = (isLoaded) => {
          if (settled) {
            return;
          }
          settled = true;
          window.clearTimeout(timeout);
          image.removeEventListener("load", handleLoad);
          image.removeEventListener("error", handleError);
          callback(isLoaded && image.naturalWidth > 0);
        };
        const handleLoad = () => settle(true);
        const handleError = () => settle(false);
        const timeout = window.setTimeout(() => settle(false), 3500);

        image.addEventListener("load", handleLoad, { once: true });
        image.addEventListener("error", handleError, { once: true });
      };

      const clearSlideState = () => {
        [mainImage, bufferImage].forEach((image) => {
          image.style.transform = "";
          image.classList.remove(
            "slide-in-right",
            "slide-in-left",
            "slide-out-right",
            "slide-out-left",
            "is-sliding-active"
          );
        });
        bufferImage.classList.remove("is-visible");
        mainImageShell?.classList.remove("is-dragging", "is-snapping", "is-sliding");
      };

      const updateLightboxImage = (slide) => {
        if (lightboxImage instanceof HTMLImageElement && lightbox instanceof HTMLElement && !lightbox.hidden && slide) {
          setImageSource(lightboxImage, slide.lightboxSrc, slide.alt, slide.lightboxSrcset, slide.lightboxSizes);
          lightboxIndex = slide.index;
          prefetchAdjacentLightboxSlides(lightboxIndex);
        }
      };

      const showLightboxIndex = (nextIndex) => {
        const slides = getSlides();
        if (!(lightbox instanceof HTMLElement) || !(lightboxImage instanceof HTMLImageElement)) {
          return;
        }
        if (nextIndex < 0 || nextIndex >= slides.length) {
          return;
        }

        const slide = slides[nextIndex];
        if (!slide?.lightboxSrc) {
          return;
        }

        const token = ++lightboxSwitchToken;
        lightboxIndex = nextIndex;
        lightbox.classList.add("is-loading");
        prefetchAdjacentLightboxSlides(nextIndex);

        preloadLightboxSlide(slide)
          .then(() => {
            if (token !== lightboxSwitchToken || lightbox.hidden) {
              return;
            }
            setImageSource(lightboxImage, slide.lightboxSrc, slide.alt, slide.lightboxSrcset, slide.lightboxSizes);
            lightbox.classList.remove("is-loading");
            prefetchAdjacentLightboxSlides(nextIndex);
          })
          .catch(() => {
            if (token !== lightboxSwitchToken) {
              return;
            }
            lightbox.classList.remove("is-loading");
          });
      };

      const setLightboxOpen = (isOpen) => {
        if (!(lightbox instanceof HTMLElement)) {
          return;
        }

        if (!isOpen) {
          lightbox.hidden = true;
          lightbox.classList.remove("is-loading");
          document.body.classList.remove("gallery-lightbox-open");
          if (lightboxIndex !== activeIndex) {
            switchToIndex(lightboxIndex);
          }
          return;
        }

        lightbox.hidden = !isOpen;
        document.body.classList.add("gallery-lightbox-open");
        if (lightboxImage instanceof HTMLImageElement) {
          lightboxIndex = activeIndex;
          const activeSlide = getSlides()[activeIndex];
          if (activeSlide) {
            setImageSource(lightboxImage, activeSlide.src, activeSlide.alt, activeSlide.srcset, activeSlide.sizes);
          }
          showLightboxIndex(lightboxIndex);
        }
      };

      const completeSlide = (nextSlide, nextIndex, token) => {
        if (token !== switchToken) {
          return;
        }

        const previousSlide = {
          src: mainImage.getAttribute("src") || mainImage.src,
          srcset: mainImage.getAttribute("srcset") || "",
          sizes: mainImage.getAttribute("sizes") || "",
          alt: mainImage.alt
        };
        mainImage.style.transition = "none";
        setImageSource(mainImage, nextSlide.src, nextSlide.alt, nextSlide.srcset, nextSlide.sizes);
        mainImage.classList.remove(
          "slide-in-right",
          "slide-in-left",
          "slide-out-right",
          "slide-out-left",
          "is-sliding-active"
        );
        mainImage.style.transform = "translateX(0)";
        void mainImage.offsetWidth;
        mainImage.style.transition = "";
        updateLightboxImage(nextSlide);
        afterImageReady(mainImage, (isReady) => {
          if (token !== switchToken) {
            return;
          }
          if (!isReady) {
            setImageSource(mainImage, previousSlide.src, previousSlide.alt, previousSlide.srcset, previousSlide.sizes);
            afterImageReady(mainImage, () => {
              if (token !== switchToken) {
                return;
              }
              clearSlideState();
              activeFinish = null;
              isAnimating = false;
            });
            return;
          }
          activeIndex = nextIndex;
          selectedIndex = nextIndex;
          syncActiveControls();
          clearSlideState();
          activeFinish = null;
          isAnimating = false;
          scheduleNearbySlidePreload(activeIndex);
        });
      };

      const switchToExternalSlide = (externalSlide) => {
        if (!externalSlide?.src) {
          return;
        }

        if (isAnimating && typeof activeFinish === "function") {
          activeFinish();
        }

        const token = ++switchToken;
        isAnimating = true;
        clearSlideState();

        preloadSlide(externalSlide, "high")
          .then(() => {
            if (token !== switchToken) {
              return;
            }

            const previousSlide = {
              src: mainImage.getAttribute("src") || mainImage.src,
              srcset: mainImage.getAttribute("srcset") || "",
              sizes: mainImage.getAttribute("sizes") || "",
              alt: mainImage.alt
            };

            setImageSource(mainImage, externalSlide.src, externalSlide.alt, externalSlide.srcset, externalSlide.sizes);
            updateLightboxImage(externalSlide);
            afterImageReady(mainImage, (isReady) => {
              if (token !== switchToken) {
                return;
              }

              if (!isReady) {
                setImageSource(mainImage, previousSlide.src, previousSlide.alt, previousSlide.srcset, previousSlide.sizes);
                afterImageReady(mainImage, () => {
                  if (token !== switchToken) {
                    return;
                  }
                  clearSlideState();
                  activeFinish = null;
                  isAnimating = false;
                });
                return;
              }

              selectedIndex = -1;
              syncActiveControls();
              clearSlideState();
              activeFinish = null;
              isAnimating = false;
            });
          })
          .catch(() => {
            if (token !== switchToken) {
              return;
            }
            clearSlideState();
            activeFinish = null;
            isAnimating = false;
          });
      };

      const animateToIndex = (nextIndex, direction) => {
        const slides = getSlides();
        if (nextIndex < 0 || nextIndex >= slides.length) {
          return;
        }

        selectControlsIndex(nextIndex);

        if (isAnimating && typeof activeFinish === "function") {
          activeFinish();
        }

        if (nextIndex === activeIndex) {
          return;
        }

        const nextSlide = slides[nextIndex];
        if (!nextSlide?.src) {
          return;
        }

        const token = ++switchToken;
        isAnimating = true;
        clearSlideState();
        activeFinish = () => {
          if (token !== switchToken) {
            return;
          }
          switchToken += 1;
          clearSlideState();
          activeFinish = null;
          isAnimating = false;
        };

        prefetchNearbySlides(nextIndex, "low");
        preloadSlide(nextSlide, "high")
          .then(() => {
            if (token !== switchToken) {
              return;
            }

            setImageSource(bufferImage, nextSlide.src, nextSlide.alt, nextSlide.srcset, nextSlide.sizes);
            const isMobile = isMobileGallery();
            const useMobileTransition = isMobile && !prefersReducedGalleryMotion();
            if (isMobile && !useMobileTransition) {
              completeSlide(nextSlide, nextIndex, token);
              return;
            }

            if (useMobileTransition) {
              mainImageShell?.classList.add("is-sliding");
              mainImage.classList.add(direction > 0 ? "slide-out-left" : "slide-out-right");
            }
            bufferImage.classList.add("is-visible", direction > 0 ? "slide-in-right" : "slide-in-left");
            void bufferImage.offsetWidth;

            requestAnimationFrame(() => {
              if (token !== switchToken) {
                return;
              }
              bufferImage.classList.add("is-sliding-active");
              bufferImage.classList.remove(direction > 0 ? "slide-in-right" : "slide-in-left");
            });

            let finished = false;
            const finish = () => {
              if (finished) {
                return;
              }
              finished = true;
              bufferImage.removeEventListener("transitionend", handleTransitionEnd);
              completeSlide(nextSlide, nextIndex, token);
            };
            const handleTransitionEnd = (event) => {
              if (event.target === bufferImage && event.propertyName === "transform") {
                finish();
              }
            };

            activeFinish = finish;
            bufferImage.addEventListener("transitionend", handleTransitionEnd);
            window.setTimeout(finish, useMobileTransition ? 300 : 360);
          })
          .catch(() => {
            if (token !== switchToken) {
              return;
            }
            clearSlideState();
            selectedIndex = activeIndex;
            syncActiveControls();
            activeFinish = null;
            isAnimating = false;
          });
      };

      const switchToIndex = (nextIndex, mobileScrollBehavior = "smooth") => {
        if (isMobileGallery() && scrollMobileGalleryToIndex(nextIndex, mobileScrollBehavior)) {
          activeIndex = nextIndex;
          selectedIndex = nextIndex;
          syncActiveControls();
          scheduleNearbySlidePreload(activeIndex);
          return;
        }

        const currentSelectedIndex = selectedIndex;
        const direction = nextIndex > currentSelectedIndex ? 1 : -1;
        animateToIndex(nextIndex, direction);
      };

      gallery.__switchToIndex = switchToIndex;
      gallery.dataset.galleryBound = "true";
      gallery.dataset.galleryReady = "true";
      gallery.dataset.activeMediaIndex = String(activeIndex);
      mainImage.addEventListener("error", restoreMainImageFallback);
      window.setTimeout(() => {
        restoreMainImageFallback();
      }, 1200);

      gallery.addEventListener("theme:gallery-select", (event) => {
        const nextIndex = Number(event.detail?.index);
        if (Number.isFinite(nextIndex)) {
          switchToIndex(nextIndex);
        }
      });

      gallery.addEventListener("theme:gallery-select-image", (event) => {
        const detail = event.detail || {};
        const mediaId = detail.mediaId ? String(detail.mediaId) : "";
        const src = detail.src || "";
        const matchingThumb = getThumbButtons().find((thumb) => {
          const thumbMediaId = thumb.getAttribute("data-media-id") || "";
          const thumbSrc = thumb.getAttribute("data-image-src") || "";
          return (mediaId && thumbMediaId === mediaId) || (src && thumbSrc === src);
        });

        if (matchingThumb) {
          const nextIndex = getThumbButtons().indexOf(matchingThumb);
          if (nextIndex >= 0) {
            switchToIndex(nextIndex);
          }
          return;
        }

        switchToExternalSlide({
          index: -1,
          src,
          srcset: detail.srcset || "",
          sizes: detail.sizes || "",
          alt: detail.alt || mainImage.alt,
          lightboxSrc: detail.lightboxSrc || src,
          lightboxSrcset: detail.lightboxSrcset || detail.srcset || "",
          lightboxSizes: detail.lightboxSizes || detail.sizes || ""
        });
      });

      if (mobileScrollGallery instanceof HTMLElement) {
        let mobileGalleryPointerStart = null;
        const updateMobileActiveIndex = (nextIndex) => {
          if (isMobileSettling) {
            return;
          }

          const slides = getSlides();
          if (nextIndex < 0 || nextIndex >= slides.length || nextIndex === selectedIndex) {
            return;
          }

          activeIndex = nextIndex;
          selectedIndex = nextIndex;
          syncActiveControls();
          scheduleNearbySlidePreload(activeIndex);
          updateLightboxImage(slides[activeIndex]);
        };

        const mobileSlides = getMobileSlides();
        if ("IntersectionObserver" in window && mobileSlides.length) {
          const mobileSlideObserver = new IntersectionObserver((entries) => {
            const visibleEntry = entries
              .filter((entry) => entry.isIntersecting)
              .sort((left, right) => right.intersectionRatio - left.intersectionRatio)[0];

            if (!visibleEntry) {
              return;
            }

            const nextIndex = mobileSlides.indexOf(visibleEntry.target);
            if (nextIndex >= 0 && visibleEntry.intersectionRatio >= 0.55) {
              updateMobileActiveIndex(nextIndex);
            }
          }, {
            root: mobileScrollGallery,
            threshold: [0.55, 0.75]
          });

          mobileSlides.forEach((slide) => mobileSlideObserver.observe(slide));
        } else {
          let mobileScrollTimer = null;
          mobileScrollGallery.addEventListener("scroll", () => {
            if (mobileScrollFrame) {
              return;
            }

            mobileScrollFrame = window.setTimeout(() => {
              mobileScrollFrame = 0;
              window.clearTimeout(mobileScrollTimer);
              mobileScrollTimer = window.setTimeout(() => updateMobileActiveIndex(getNearestMobileSlideIndex()), 60);
            }, 80);
          }, { passive: true });
        }

        mobileScrollGallery.addEventListener("pointerdown", (event) => {
          if (!isMobileGallery() || event.pointerType === "mouse") {
            mobileGalleryPointerStart = null;
            return;
          }

          mobileGalleryPointerStart = {
            x: event.clientX,
            y: event.clientY,
            scrollLeft: mobileScrollGallery.scrollLeft,
            index: getNearestMobileSlideIndex()
          };
        }, { passive: true });

        mobileScrollGallery.addEventListener("pointerup", (event) => {
          if (!mobileGalleryPointerStart || !isMobileGallery()) {
            mobileGalleryPointerStart = null;
            return;
          }

          const deltaX = Math.abs(event.clientX - mobileGalleryPointerStart.x);
          const deltaY = Math.abs(event.clientY - mobileGalleryPointerStart.y);
          const rawDeltaX = event.clientX - mobileGalleryPointerStart.x;
          const rawScrollDelta = mobileScrollGallery.scrollLeft - mobileGalleryPointerStart.scrollLeft;
          const scrollDelta = Math.abs(rawScrollDelta);
          const startIndex = mobileGalleryPointerStart.index;
          mobileGalleryPointerStart = null;

          if (deltaX > 8 || deltaY > 8 || scrollDelta > 8) {
            if (deltaX > deltaY || scrollDelta > 12) {
              const slides = getSlides();
              const direction = rawScrollDelta > 12 ? 1 : rawScrollDelta < -12 ? -1 : rawDeltaX < 0 ? 1 : -1;
              const targetIndex = Math.max(0, Math.min(slides.length - 1, startIndex + direction));
              scrollMobileGalleryToIndex(targetIndex, "settle");
            }
            return;
          }

          updateMobileActiveIndex(getNearestMobileSlideIndex());
        }, { passive: true });

        mobileScrollGallery.addEventListener("pointercancel", () => {
          mobileGalleryPointerStart = null;
        }, { passive: true });
      }

      gallery.addEventListener("click", (event) => {
        const thumb = event.target.closest("[data-media-trigger]");
        if (thumb instanceof HTMLElement && gallery.contains(thumb)) {
          event.preventDefault();
          event.stopPropagation();
          const nextIndex = getThumbButtons().indexOf(thumb);
          if (nextIndex >= 0) {
            switchToIndex(nextIndex);
          }
          return;
        }

        const dot = event.target.closest("[data-dot-trigger]");
        if (dot instanceof HTMLElement && gallery.contains(dot)) {
          event.preventDefault();
          event.stopPropagation();
          const nextIndex = getDotButtons().indexOf(dot);
          if (nextIndex >= 0) {
            switchToIndex(nextIndex);
          }
        }
      });

      mainImageShell?.addEventListener("click", () => {
        if (window.matchMedia("(min-width: 821px)").matches) {
          setLightboxOpen(true);
        }
      });

      lightbox?.querySelectorAll("[data-lightbox-close]").forEach((button) => {
        button.addEventListener("click", () => setLightboxOpen(false));
      });

      lightbox?.querySelector("[data-lightbox-prev]")?.addEventListener("click", () => {
        if (lightboxIndex > 0) {
          showLightboxIndex(lightboxIndex - 1);
        }
      });

      lightbox?.querySelector("[data-lightbox-next]")?.addEventListener("click", () => {
        const slides = getSlides();
        if (lightboxIndex < slides.length - 1) {
          showLightboxIndex(lightboxIndex + 1);
        }
      });

      document.addEventListener("keydown", (event) => {
        if (!(lightbox instanceof HTMLElement) || lightbox.hidden) {
          return;
        }

        const slideCount = getSlides().length;

        if (event.key === "Escape") {
          setLightboxOpen(false);
        } else if (event.key === "ArrowLeft" && lightboxIndex > 0) {
          showLightboxIndex(lightboxIndex - 1);
        } else if (event.key === "ArrowRight" && lightboxIndex < slideCount - 1) {
          showLightboxIndex(lightboxIndex + 1);
        }
      });

      if (!isShopifyDesignMode) {
        getThumbButtons().forEach((button, index) => {
          const handleIntent = () => prefetchSlideAt(index);
          button.addEventListener("mouseenter", handleIntent, { passive: true });
          button.addEventListener("focus", handleIntent);
        });
      }

      if (!isShopifyDesignMode && "IntersectionObserver" in window) {
        const visibilityObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              scheduleNearbySlidePreload(activeIndex);
              observer.disconnect();
            }
          });
        }, { rootMargin: "200px" });
        visibilityObserver.observe(gallery);
      } else if (!isShopifyDesignMode) {
        scheduleNearbySlidePreload(activeIndex);
      }

      syncActiveControls();
    });
  };

  const initProductForms = () => {
    document.querySelectorAll("[data-product-form]").forEach((form) => {
      if (!(form instanceof HTMLElement) || form.dataset.productFormBound === "true") {
        return;
      }

      const variantJson = form.querySelector("[data-variant-json]");
      const variantIdInput = form.querySelector("[data-variant-id-input]");
      const priceRoot = form.parentElement?.querySelector("[data-price-root]");
      const priceText = priceRoot?.querySelector("[data-price]");
      const comparePriceText = priceRoot?.querySelector("[data-compare-price]");
      const savePriceText = priceRoot?.querySelector("[data-save-price]");
      const customInlineSalePrice = priceRoot?.querySelector("[data-custom-inline-sale-price]");
      const customInlineOriginal = priceRoot?.querySelector("[data-custom-inline-sale-original]");
      const customInlineCurrent = priceRoot?.querySelector("[data-custom-inline-sale-current]");
      const customInlineBadge = priceRoot?.querySelector("[data-custom-inline-sale-badge]");
      const originalPriceCents = Number(priceRoot?.getAttribute("data-original-price-cents")) || 0;
      const originalPriceMoney = priceRoot?.getAttribute("data-original-price-money") || formatMoney(originalPriceCents);
      const stockLine = form.querySelector("[data-stock-line]");
      const stockText = form.querySelector("[data-stock-text]");
      const addToCart = form.querySelector("[data-add-to-cart]");
      const quantityInput = form.querySelector("[data-tier-quantity-input]");
      const quantityTiers = form.querySelector("[data-quantity-tiers]") || form.parentElement?.querySelector("[data-quantity-tiers]");
      const tierCards = Array.from(quantityTiers?.querySelectorAll("[data-tier-card]") || []);
      const optionGroups = Array.from(form.querySelectorAll("[data-option-group]"));
      const gallery = document.querySelector("[data-product-gallery]");
      const galleryMainImage = gallery?.querySelector("[data-main-image]");
      let productImageSwitchToken = 0;
      let urlSelectedVariant = null;
      let activeProductVariant = null;

      if (!variantJson || !variantIdInput || !addToCart) {
        return;
      }

      let variants = [];
      try {
        variants = JSON.parse(variantJson.textContent || "[]");
      } catch (_error) {
        return;
      }

      form.dataset.productFormBound = "true";

      const normalizeOptionName = (name = "") => String(name).trim().replace(/\s+/g, " ").toLowerCase();
      const normalizeOptionValue = (value = "") => String(value).trim().replace(/\s+/g, " ").toLowerCase().replace(/\bgray\b/g, "grey");
      const optionValuesMatch = (left, right) => normalizeOptionValue(left) === normalizeOptionValue(right);
      const optionCount = variants.reduce((count, variant) => Math.max(count, Array.isArray(variant.options) ? variant.options.length : 0), 0);
      const normalizeOptionArray = (options = [], emptyValue = "") =>
        Array.from({ length: optionCount }, (_value, index) => normalizeOptionValue(options[index] || emptyValue));
      const getOptionsKey = (options = []) => normalizeOptionArray(options).join("||");
      const getPartialOptionsKey = (options = []) =>
        Array.from({ length: optionCount }, (_value, index) => options[index] ? normalizeOptionValue(options[index]) : "*").join("||");
      const variantByOptionsKey = new Map();
      const variantById = new Map();
      const availableVariantByPartialKey = new Map();

      variants.forEach((variant) => {
        if (variant?.id) {
          variantById.set(String(variant.id), variant);
        }
        if (Array.isArray(variant.options)) {
          variantByOptionsKey.set(getOptionsKey(variant.options), variant);
        }
      });

      const isColourOptionName = (name = "") => {
        const normalized = normalizeOptionName(name);
        return normalized === "colour" || normalized === "color" || normalized.includes("colour") || normalized.includes("color");
      };
      const optionMeta = optionGroups.map((group, groupIndex) => {
        const firstButton = group.querySelector("[data-option-value]");
        const optionName = firstButton?.getAttribute("data-option-name") || "";
        const optionPosition = Number(group.getAttribute("data-option-position")) || groupIndex + 1;
        return {
          group,
          groupIndex,
          optionIndex: optionPosition - 1,
          optionName,
          isColour: isColourOptionName(optionName)
        };
      });

      const getSelectedTierCard = () =>
        tierCards.find((card) => card.getAttribute("aria-pressed") === "true") || tierCards[0] || null;

      const readSelectedOptions = () =>
        optionMeta.reduce((selectedOptions, { group, optionIndex }) => {
          const selected = group.querySelector("[aria-pressed='true']");
          selectedOptions[optionIndex] = selected ? selected.getAttribute("data-option-value") : null;
          return selectedOptions;
        }, []);

      const setSelectedButton = (button, { force = false } = {}) => {
        if (!(button instanceof HTMLButtonElement) || (button.disabled && !force)) {
          return;
        }

        const optionPosition = button.getAttribute("data-option-position");
        const group = form.querySelector(`[data-option-group][data-option-position='${optionPosition}']`);
        if (!group) {
          return;
        }

        group.querySelectorAll("[data-option-value]").forEach((candidate) => {
          const isActive = candidate === button && !candidate.disabled;
          candidate.setAttribute("aria-pressed", String(isActive));
          candidate.classList.toggle("is-selected", isActive);
        });
      };

      const clearSelectedButton = (group) => {
        group.querySelectorAll("[data-option-value]").forEach((candidate) => {
          candidate.setAttribute("aria-pressed", "false");
          candidate.classList.remove("is-selected");
        });
      };

      const findExactVariant = (selectedOptions) => {
        const normalizedOptions = normalizeOptionArray(selectedOptions);
        if (normalizedOptions.length !== optionCount || normalizedOptions.some((value) => !value)) {
          return null;
        }

        return variantByOptionsKey.get(normalizedOptions.join("||")) || null;
      };

      const hasAvailableVariantForOptionValue = (meta, optionValue, selectedOptions) => {
        const candidateOptions = meta.isColour ? [] : [...selectedOptions];
        candidateOptions[meta.optionIndex] = optionValue;
        return Boolean(findAvailableVariantForOptions(candidateOptions));
      };

      const getOptionValuesForMeta = (meta) =>
        Array.from(meta?.group?.querySelectorAll("[data-option-value]") || [])
          .map((button) => button.getAttribute("data-option-value"))
          .filter((value, index, values) => value && values.findIndex((candidate) => optionValuesMatch(candidate, value)) === index);

      const findAvailableVariantForOptions = (selectedOptions) => {
        const cacheKey = getPartialOptionsKey(selectedOptions);
        if (availableVariantByPartialKey.has(cacheKey)) {
          return availableVariantByPartialKey.get(cacheKey);
        }

        const availableVariant = variants.find((variant) => (
          variant.available &&
          variant.options.every((value, index) => !selectedOptions[index] || optionValuesMatch(value, selectedOptions[index]))
        )) || null;
        availableVariantByPartialKey.set(cacheKey, availableVariant);
        return availableVariant;
      };

      const findExactAvailableVariant = (selectedOptions) => {
        const exactVariant = findExactVariant(selectedOptions);
        return exactVariant?.available ? exactVariant : null;
      };

      const getPricingVariant = () => (
        activeProductVariant ||
        findExactVariant(readSelectedOptions()) ||
        variants.find((variant) => variant.available) ||
        variants[0] ||
        null
      );

      const variantHasImage = (variant) => Boolean(variant?.featured_media_id || variant?.featured_media_src);

      const variantMatchesColour = (variant, colourMeta, colourValue) => (
        colourMeta &&
        colourValue &&
        optionValuesMatch(variant.options[colourMeta.optionIndex], colourValue)
      );

      const findVariantImageForSelectedColour = () => {
        const colourMeta = optionMeta.find((meta) => meta.isColour);
        if (!colourMeta) {
          return null;
        }

        const selectedOptions = readSelectedOptions();
        const selectedColour = selectedOptions[colourMeta.optionIndex];
        if (!selectedColour) {
          return null;
        }

        const colourVariants = variants.filter((variant) => variantMatchesColour(variant, colourMeta, selectedColour));
        const hasSecondarySelections = optionMeta.some((meta) => meta.optionIndex !== colourMeta.optionIndex && selectedOptions[meta.optionIndex]);

        if (hasSecondarySelections) {
          const exactVariantWithImage = colourVariants.find((variant) => (
            variantHasImage(variant) &&
            variant.options.every((value, index) => !selectedOptions[index] || optionValuesMatch(value, selectedOptions[index]))
          ));
          if (exactVariantWithImage) {
            return exactVariantWithImage;
          }
        }

        return (
          colourVariants.find((variant) => variant.available && variantHasImage(variant)) ||
          colourVariants.find((variant) => variantHasImage(variant)) ||
          null
        );
      };

      const setOptionButtonAvailability = (button, isAvailable) => {
        if (!(button instanceof HTMLButtonElement)) {
          return;
        }

        const shouldKeepSelected = urlSelectedVariant && button.getAttribute("aria-pressed") === "true";
        button.disabled = !isAvailable;
        button.setAttribute("aria-disabled", String(!isAvailable));
        button.classList.toggle("is-disabled", !isAvailable);
        button.classList.toggle("is-sold-out", !isAvailable);
        button.classList.toggle("is-unavailable", false);

        if (!isAvailable && !shouldKeepSelected) {
          button.setAttribute("aria-pressed", "false");
          button.classList.remove("is-selected");
        }
      };

      const syncOptionAvailability = () => {
        for (let pass = 0; pass < 2; pass += 1) {
          const selectedOptions = readSelectedOptions();

          optionMeta.forEach((meta) => {
            meta.group.querySelectorAll("[data-option-value]").forEach((button) => {
              const optionValue = button.getAttribute("data-option-value");
              const isAvailable = hasAvailableVariantForOptionValue(meta, optionValue, selectedOptions);
              setOptionButtonAvailability(button, isAvailable);
            });
          });

          optionMeta.forEach((meta) => {
            const shouldKeepUrlSelection = urlSelectedVariant && meta.group.querySelector("[aria-pressed='true']");
            if (!meta.group.querySelector("[data-option-value]:not(:disabled)") && !shouldKeepUrlSelection) {
              clearSelectedButton(meta.group);
            }
          });
        }
      };

      const updateVariantUrl = (variant) => {
        if (!window.history?.replaceState) {
          return;
        }

        const url = new URL(window.location.href);
        if (variant && variant.id) {
          url.searchParams.set("variant", String(variant.id));
        } else {
          url.searchParams.delete("variant");
        }
        window.history.replaceState({}, document.title, url.toString());
      };

      const syncBaseBundleImageForVariant = (variant) => {
        if (!variantHasImage(variant)) {
          return;
        }

        const baseImage = document.querySelector("[data-bundle-base] .bundle-item-image img");
        if (!(baseImage instanceof HTMLImageElement)) {
          return;
        }

        const nextSrc = variant.bundle_image_src || variant.featured_media_src || "";
        const nextSrcset = variant.bundle_image_srcset || "";
        const nextAlt = variant.featured_media_alt || baseImage.alt;
        if (!nextSrc) {
          return;
        }

        if (nextSrcset) {
          baseImage.srcset = nextSrcset;
          baseImage.sizes = "58px";
        } else {
          baseImage.removeAttribute("srcset");
          baseImage.removeAttribute("sizes");
        }

        baseImage.src = nextSrc;
        baseImage.alt = nextAlt;
      };

      const syncGalleryForVariantImage = (variant) => {
        if (!gallery || !galleryMainImage || !variantHasImage(variant)) {
          return false;
        }

        const imageDetail = {
          mediaId: variant.featured_media_id,
          src: variant.featured_media_src,
          alt: variant.featured_media_alt,
          lightboxSrc: variant.featured_media_src
        };

        if (gallery.dataset.galleryReady === "true") {
          gallery.dispatchEvent(new CustomEvent("theme:gallery-select-image", { detail: imageDetail }));
        } else if (imageDetail.src) {
          const token = ++productImageSwitchToken;
          const nextImage = new Image();
          nextImage.decoding = "async";
          nextImage.onload = () => {
            if (token !== productImageSwitchToken || nextImage.naturalWidth <= 0) {
              return;
            }
            galleryMainImage.removeAttribute("srcset");
            galleryMainImage.removeAttribute("sizes");
            galleryMainImage.src = imageDetail.src;
            galleryMainImage.alt = imageDetail.alt || galleryMainImage.alt;
          };
          nextImage.src = imageDetail.src;
        }

        syncBaseBundleImageForVariant(variant);
        return true;
      };

      const syncGalleryForSelectedColour = () => {
        const colourImageVariant = findVariantImageForSelectedColour();
        if (!colourImageVariant) {
          return false;
        }

        return syncGalleryForVariantImage(colourImageVariant);
      };

      const applyVariantSelection = (variant) => {
        if (!variant || !Array.isArray(variant.options)) {
          return false;
        }

        optionMeta.forEach((meta) => {
          const targetValue = variant.options[meta.optionIndex];
          const matchingButton = Array.from(meta.group.querySelectorAll("[data-option-value]")).find((button) => {
            return optionValuesMatch(button.getAttribute("data-option-value"), targetValue);
          });

          if (matchingButton instanceof HTMLButtonElement) {
            setSelectedButton(matchingButton, { force: true });
          } else {
            clearSelectedButton(meta.group);
          }
        });

        return true;
      };

      const applyUrlVariantSelection = () => {
        const variantId = new URLSearchParams(window.location.search).get("variant");
        if (!variantId) {
          urlSelectedVariant = null;
          return false;
        }

        const matchingVariant = variantById.get(String(variantId));
        urlSelectedVariant = matchingVariant || null;
        return applyVariantSelection(matchingVariant);
      };

      const syncGalleryForVariant = (variant) => {
        if (!gallery || !galleryMainImage || !variantHasImage(variant)) {
          return false;
        }

        return syncGalleryForVariantImage(variant);
      };
      const getTierPricingForVariant = (variant, card = getSelectedTierCard()) => {
        const basePrice = Number(variant?.price) || 0;
        const quantity = Number(card?.getAttribute("data-tier-quantity")) || 1;
        const discount = Number(card?.getAttribute("data-tier-discount")) || 0;

        if (discount <= 0) {
          return {
            unitPrice: basePrice,
            totalPrice: basePrice * quantity
          };
        }

        const rawTotal = basePrice * quantity * ((100 - discount) / 100);
        const totalPrice = Math.round(rawTotal);
        return {
          unitPrice: Math.round(totalPrice / quantity),
          totalPrice
        };
      };

      const hasCustomOriginalPrice = (variant) => originalPriceCents > 0 && originalPriceCents > (Number(variant?.price) || 0);
      const getVariantMoney = (variant, cents) => (
        Number(cents) === Number(variant?.price) && variant?.price_money ? variant.price_money : formatMoney(cents)
      );

      const setAddToCartText = (label) => {
        addToCart.textContent = label;
      };

      const setAddToCartSaleLabel = (variant, currentPriceCents) => {
        addToCart.innerHTML = "";
        const quantity = Number(getSelectedTierCard()?.getAttribute("data-tier-quantity")) || 1;
        const originalTotalPriceCents = originalPriceCents * quantity;

        const wrapper = document.createElement("span");
        wrapper.className = "custom-atc-sale-price";
        wrapper.setAttribute("data-custom-atc-sale-price", "");

        const label = document.createElement("span");
        label.textContent = "ADD TO CART - ";

        const originalPrice = document.createElement("span");
        originalPrice.className = "custom-atc-original-price";
        const originalPriceStrike = document.createElement("s");
        originalPriceStrike.textContent = formatMoney(originalTotalPriceCents);
        originalPrice.append(originalPriceStrike);

        const currentPrice = document.createElement("span");
        currentPrice.className = "custom-atc-current-price";
        currentPrice.textContent = getVariantMoney(variant, currentPriceCents);

        wrapper.append(label, originalPrice, currentPrice);
        addToCart.append(wrapper);
      };

      const syncPriceDisplay = (variant) => {
        const hasCustomSale = hasCustomOriginalPrice(variant);
        if (customInlineSalePrice) {
          customInlineSalePrice.hidden = !hasCustomSale;
        }
        if (customInlineCurrent) {
          customInlineCurrent.textContent = variant.price_money;
        }
        if (priceText) {
          priceText.textContent = variant.price_money;
          priceText.hidden = hasCustomSale;
        }
        if (customInlineOriginal) {
          const originalPriceStrike = customInlineOriginal.querySelector("s");
          if (originalPriceStrike) {
            originalPriceStrike.textContent = originalPriceMoney;
          } else {
            customInlineOriginal.textContent = originalPriceMoney;
          }
        }
        if (customInlineBadge) {
          customInlineBadge.textContent = "Sale";
        }
        if (comparePriceText && savePriceText) {
          const hasCompare = !hasCustomSale && Number(variant.compare_at_price) > Number(variant.price);
          comparePriceText.textContent = hasCompare ? variant.compare_at_price_money : "";
          savePriceText.textContent = hasCompare ? `Save ${variant.save_money}` : "";
          comparePriceText.hidden = !hasCompare;
          savePriceText.hidden = !hasCompare;
        }
      };

      const syncAddToCartLabel = (variant) => {
        if (!(addToCart instanceof HTMLButtonElement)) {
          return;
        }

        if (!variant) {
          return;
        }

        if (!variant.available) {
          setAddToCartText("Sold Out");
          return;
        }

        const { totalPrice } = getTierPricingForVariant(variant);
        if (hasCustomOriginalPrice(variant)) {
          setAddToCartSaleLabel(variant, totalPrice);
          return;
        }

        setAddToCartText(`Add to Bag - ${getVariantMoney(variant, totalPrice)}`);
      };

      const setSelectedTier = (card) => {
        if (!(card instanceof HTMLButtonElement)) {
          return;
        }

        const quantity = Number(card.getAttribute("data-tier-quantity")) || 1;
        const isAlreadySelected = card.getAttribute("aria-pressed") === "true";
        if (quantityInput instanceof HTMLInputElement) {
          quantityInput.value = String(quantity);
        }

        if (isAlreadySelected) {
          return;
        }

        tierCards.forEach((candidate) => {
          const isSelected = candidate === card;
          candidate.classList.toggle("is-selected", isSelected);
          candidate.setAttribute("aria-pressed", String(isSelected));
        });

        if (activeProductVariant) {
          addToCart.disabled = !activeProductVariant.available;
          syncAddToCartLabel(activeProductVariant);
        } else {
          syncVariantState();
        }
      };

      const syncQuantityTierPrices = (variant) => {
        const basePrice = Number(variant?.price) || 0;
        if (!basePrice || !tierCards.length) {
          return;
        }

        tierCards.forEach((card) => {
          const { unitPrice } = getTierPricingForVariant(variant, card);
          const unitPriceText = card.querySelector("[data-tier-unit-price]");

          if (unitPriceText instanceof HTMLElement) {
            unitPriceText.textContent = formatMoney(unitPrice);
          }
        });
      };
      const syncVariantState = () => {
        syncOptionAvailability();
        const currentVariantFromInput = variantById.get(String(variantIdInput.value));
        const selectedOptions = optionGroups.length ? readSelectedOptions() : currentVariantFromInput?.options || variants[0]?.options || [];
        const hasMissingSelection = optionGroups.length > 0 && variants[0]?.options?.some((_value, index) => !selectedOptions[index]);
        const matchedVariant = hasMissingSelection ? null : findExactVariant(selectedOptions);

        if (!matchedVariant) {
          activeProductVariant = null;
          addToCart.disabled = true;
          variantIdInput.value = "";
          setAddToCartText(hasMissingSelection ? "Choose your options" : "Unavailable");
          if (hasMissingSelection) {
            updateVariantUrl(null);
          }
          if (stockLine && stockText) {
            stockLine.hidden = hasMissingSelection;
            stockLine.classList.toggle("is-sold-out", !hasMissingSelection);
            stockLine.classList.remove("is-ready");
            stockText.textContent = hasMissingSelection ? "" : "Unavailable";
          }
          return null;
        }

        activeProductVariant = matchedVariant;
        variantIdInput.value = matchedVariant.id;
        updateVariantUrl(matchedVariant);

        syncPriceDisplay(matchedVariant);

        syncQuantityTierPrices(matchedVariant);

        if (stockLine && stockText) {
          stockLine.hidden = false;
          stockLine.classList.toggle("is-sold-out", !matchedVariant.available);
          stockLine.classList.toggle("is-ready", matchedVariant.available);
          stockText.textContent = matchedVariant.available ? "In stock" : "Sold out";
        }

        addToCart.disabled = !matchedVariant.available;
        syncAddToCartLabel(matchedVariant);

        if (!syncGalleryForVariant(matchedVariant)) {
          syncGalleryForSelectedColour();
        }
        return matchedVariant;
      };

      form.addEventListener("click", (event) => {
        const target = event.target;
        if (!(target instanceof Element)) {
          return;
        }

        const tierCard = target.closest("[data-tier-card]");
        if (tierCard instanceof HTMLButtonElement && form.contains(tierCard)) {
          setSelectedTier(tierCard);
          return;
        }

        const optionButton = target.closest("[data-option-value]");
        if (!(optionButton instanceof HTMLButtonElement) || !form.contains(optionButton) || optionButton.disabled || optionButton.getAttribute("aria-disabled") === "true") {
          return;
        }

        urlSelectedVariant = null;
        setSelectedButton(optionButton);
        if (optionMeta.some((meta) => meta.isColour && meta.group.contains(optionButton))) {
          syncGalleryForSelectedColour();
        }
        syncOptionAvailability();
        syncVariantState();
      });

      const initiallySelectedTier = tierCards.find((card) => card.getAttribute("aria-pressed") === "true") || tierCards[0];
      if (initiallySelectedTier) {
        setSelectedTier(initiallySelectedTier);
      }

      syncVariantState();

      form.addEventListener("submit", async (event) => {
        event.preventDefault();
        const activeVariant = syncVariantState();
        if (!activeVariant || !activeVariant.available) {
          return;
        }

        const formData = new FormData(form);
        addToCart.disabled = true;
        setAddToCartText("Adding...");
        let addSucceeded = false;

        try {
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: { Accept: "application/json" },
            body: formData
          });

          if (!response.ok) {
            throw new Error(`Add to cart failed: ${response.status}`);
          }

          addSucceeded = true;
          const shouldRefreshCartPage = document.body.classList.contains("cart-page");
          const sectionNames = ["header", "cart-drawer"];
          try {
            await refreshSections(sectionNames, "/");
            if (shouldRefreshCartPage) {
              await refreshCartPageContent();
            }
            initCartDrawer();
          } catch (refreshError) {
            if (!(refreshError instanceof DOMException && refreshError.name === "AbortError")) {
              console.warn("Cart refresh failed after product add; falling back to cart JSON.", refreshError);
            }

            try {
              const fallbackCart = await fetchCartJson();
              syncCartFallbackDisplay(fallbackCart);
            } catch (cartError) {
              console.warn("Cart JSON fallback failed after product add.", cartError);
            }

            if (shouldRefreshCartPage) {
              window.location.reload();
              return;
            }
          }
          setCartDrawerOpen(true);
        } catch (_error) {
          if (!addSucceeded) {
            window.location.href = cartUrl;
            return;
          }
        } finally {
          addToCart.disabled = !activeVariant.available;
          syncAddToCartLabel(activeVariant);
        }
      });

      syncVariantState();
    });
  };

  const initProductBundles = () => {
    const roundBundlePrice = (rawCents) => {
      const safeCents = Math.max(0, Number(rawCents) || 0);
      const nearestWhole = Math.round(safeCents / 100) * 100;
      const nearestNinetyNine = Math.round((safeCents - 99) / 100) * 100 + 99;
      return Math.abs(nearestWhole - safeCents) <= Math.abs(nearestNinetyNine - safeCents) ? nearestWhole : nearestNinetyNine;
    };

    document.querySelectorAll("[data-bundle-root]").forEach((bundle) => {
      if (!(bundle instanceof HTMLElement) || bundle.dataset.bundleBound === "true") {
        return;
      }

      bundle.dataset.bundleBound = "true";

      const purchasePanel = bundle.closest(".purchase-panel");
      const productForm = purchasePanel?.querySelector("[data-product-form]");
      const baseVariantJson = productForm?.querySelector("[data-variant-json]");
      const baseVariantInput = productForm?.querySelector("[data-variant-id-input]");
      const baseAddToCartButton = productForm?.querySelector("[data-add-to-cart]");
      const baseOptionGroups = Array.from(productForm?.querySelectorAll("[data-option-group]") || []);
      const bundleAddButton = bundle.querySelector("[data-bundle-add]");
      const bundleError = bundle.querySelector("[data-bundle-error]");
      const originalPriceText = bundle.querySelector("[data-bundle-original-price]");
      const discountedPriceText = bundle.querySelector("[data-bundle-discounted-price]");
      const savingText = bundle.querySelector("[data-bundle-saving]");
      const bundleSuccess = bundle.querySelector("[data-bundle-success]");
      const bundleSuccessList = bundle.querySelector("[data-bundle-success-list]");
      const modalRoot = purchasePanel?.querySelector("[data-bundle-modal-root]");
      const modalBody = modalRoot?.querySelector("[data-bundle-modal-body]");
      const modalTitle = modalRoot?.querySelector("[data-bundle-modal-title]");
      const modalPrice = modalRoot?.querySelector("[data-bundle-modal-price]");
      const modalImage = modalRoot?.querySelector("[data-bundle-modal-image]");
      const modalProgress = modalRoot?.querySelector("[data-bundle-modal-progress]");
      const modalConfirm = modalRoot?.querySelector("[data-bundle-modal-confirm]");
      const modalError = modalRoot?.querySelector("[data-bundle-modal-error]");
      const bundleItems = Array.from(bundle.querySelectorAll("[data-bundle-item]"));
      const discountPercent = Number(bundle.getAttribute("data-bundle-discount-percent")) || 15;
      let pendingBundleItems = [];
      let pendingBundleIndex = 0;
      let isSubmittingBundle = false;

      if (!(bundleAddButton instanceof HTMLButtonElement) || !(baseVariantInput instanceof HTMLInputElement) || !baseVariantJson) {
        return;
      }

      let baseVariants = [];
      try {
        baseVariants = JSON.parse(baseVariantJson.textContent || "[]");
      } catch (_error) {
        return;
      }

      const getActiveBaseVariant = () => {
        const currentId = String(baseVariantInput.value || "");
        return baseVariants.find((variant) => String(variant.id) === currentId) || null;
      };

      const isBaseSelectionIncomplete = () => {
        if (!baseOptionGroups.length) {
          return false;
        }

        const hasMissingOption = baseOptionGroups.some((group) => !group.querySelector("[aria-pressed='true']"));
        if (hasMissingOption) {
          return true;
        }

        return !getActiveBaseVariant();
      };

      const getActiveBundleItems = () =>
        bundleItems.filter(
          (item) =>
            item instanceof HTMLElement &&
            !item.hidden &&
            item.getAttribute("data-bundle-excluded") !== "true"
        );

      const dedupeRenderedBundleItems = () => {
        const seenProductIds = new Set();

        bundleItems.forEach((item) => {
          if (!(item instanceof HTMLElement) || item.hasAttribute("data-bundle-base")) {
            return;
          }

          const productId = item.getAttribute("data-product-id");
          if (!productId) {
            return;
          }

          if (seenProductIds.has(productId)) {
            item.hidden = true;
            item.setAttribute("data-bundle-excluded", "true");
            return;
          }

          seenProductIds.add(productId);
        });
      };

      const excludeBundleItem = (item) => {
        if (!(item instanceof HTMLElement) || item.hasAttribute("data-bundle-base")) {
          return;
        }

        item.hidden = true;
        item.setAttribute("data-bundle-excluded", "true");
        const variantIdInput = item.querySelector("[data-bundle-variant-id]");
        const priceInput = item.querySelector("[data-bundle-price-cents]");
        if (variantIdInput instanceof HTMLInputElement) {
          variantIdInput.value = "";
        }
        if (priceInput instanceof HTMLInputElement) {
          priceInput.value = "0";
        }
      };

      const clearBundleFeedback = () => {
        if (bundleError instanceof HTMLElement) {
          bundleError.textContent = "";
        }
        if (bundleSuccess instanceof HTMLElement) {
          bundleSuccess.hidden = true;
        }
        if (bundleSuccessList instanceof HTMLElement) {
          bundleSuccessList.innerHTML = "";
        }
      };

      const buildVariantSummary = (variant) => {
        if (!variant) {
          return "";
        }

        if (typeof variant.title === "string" && variant.title && variant.title !== "Default Title") {
          return variant.title;
        }

        if (Array.isArray(variant.options)) {
          const selected = variant.options.filter((value) => typeof value === "string" && value && value !== "Default Title");
          if (selected.length) {
            return selected.join(" / ");
          }
        }

        return "";
      };

      const getItemVariantData = (item, variantId) => {
        if (!(item instanceof HTMLElement) || !variantId) {
          return null;
        }

        if (item.hasAttribute("data-bundle-base")) {
          return baseVariants.find((variant) => String(variant.id) === String(variantId)) || null;
        }

        const variantScript = item.querySelector("[data-bundle-variants]");
        if (!variantScript) {
          return null;
        }

        try {
          const variants = JSON.parse(variantScript.textContent || "[]");
          return variants.find((variant) => String(variant.id) === String(variantId)) || null;
        } catch (_error) {
          return null;
        }
      };

      const updateBundleItemImage = (item, variant) => {
        if (!(item instanceof HTMLElement)) {
          return;
        }

        const image = item.querySelector(".bundle-item-image img");
        if (!(image instanceof HTMLImageElement) || !variant) {
          return;
        }

        const nextSrc = variant.featured_image_src || variant.featured_media_src || "";
        const nextAlt = variant.featured_image_alt || variant.featured_media_alt || item.getAttribute("data-product-title") || image.alt;
        if (!nextSrc) {
          return;
        }

        image.removeAttribute("srcset");
        image.removeAttribute("sizes");
        image.src = nextSrc;
        image.alt = nextAlt;
      };

      const syncBaseBundleImage = (item, variant) => {
        if (!(item instanceof HTMLElement)) {
          return;
        }

        const image = item.querySelector(".bundle-item-image img");
        if (!(image instanceof HTMLImageElement)) {
          return;
        }

        const galleryImage = document.querySelector("[data-product-gallery] [data-main-image]");
        const nextSrc = variant?.bundle_image_src || variant?.featured_media_src || galleryImage?.currentSrc || galleryImage?.src || image.src;
        const nextSrcset = variant?.bundle_image_srcset || "";
        const nextAlt = variant?.featured_media_alt || item.getAttribute("data-product-title") || galleryImage?.alt || image.alt;

        if (!nextSrc) {
          return;
        }

        if (nextSrcset) {
          image.srcset = nextSrcset;
          image.sizes = "58px";
        } else {
          image.removeAttribute("srcset");
          image.removeAttribute("sizes");
        }

        image.decoding = "async";
        image.src = nextSrc;
        image.alt = nextAlt;
      };

      const renderBundleSuccess = (lineItems) => {
        if (!(bundleSuccess instanceof HTMLElement) || !(bundleSuccessList instanceof HTMLElement)) {
          return;
        }

        const escapeHtml = (value = "") =>
          String(value)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#39;");

        bundleSuccessList.innerHTML = lineItems
          .map((entry) => {
            const label = entry.summary ? `${entry.title} - ${entry.summary}` : entry.title;
            const safeLabel = escapeHtml(label);
            return `<li>${safeLabel}</li>`;
          })
          .join("");
        bundleSuccess.hidden = false;
      };

      const normalizeBundleOptionName = (name = "") => String(name).trim().toLowerCase();
      const isBundleColourOption = (name = "") => {
        const normalized = normalizeBundleOptionName(name);
        return normalized === "colour" || normalized === "color" || normalized.includes("colour") || normalized.includes("color");
      };

      const getBundleOptionName = (group) => {
        const controlName = group.querySelector("[data-option-name]")?.getAttribute("data-option-name");
        const labelName = group.querySelector(".bundle-option-label")?.textContent;
        return controlName || labelName || "";
      };

      const getBundleOptionMeta = (item) =>
        Array.from(item.querySelectorAll("[data-bundle-option-group]")).map((group, groupIndex) => {
          const optionPosition = Number(group.getAttribute("data-option-position")) || groupIndex + 1;
          const optionName = getBundleOptionName(group);
          return {
            group,
            optionIndex: optionPosition - 1,
            optionName,
            isColour: isBundleColourOption(optionName)
          };
        });

      const readBundleSelectedOptions = (optionMeta) =>
        optionMeta.reduce((selectedOptions, meta) => {
          const select = meta.group.querySelector("select[data-bundle-select]");
          if (select instanceof HTMLSelectElement) {
            const selectedOption = select.selectedOptions[0];
            selectedOptions[meta.optionIndex] = selectedOption && !selectedOption.disabled ? select.value || null : null;
            return selectedOptions;
          }

          const selectedButton = meta.group.querySelector("[aria-pressed='true']:not(:disabled)");
          selectedOptions[meta.optionIndex] = selectedButton ? selectedButton.getAttribute("data-option-value") : null;
          return selectedOptions;
        }, []);

      const bundleVariantMatchesSelections = (variant, selectedOptions, ignoredIndex = -1) =>
        variant.options.every((value, index) => index === ignoredIndex || !selectedOptions[index] || value === selectedOptions[index]);

      const isBundleOptionValueAvailable = (variants, meta, optionValue, selectedOptions) => {
        if (meta.isColour) {
          return variants.some((variant) => variant.available && variant.options[meta.optionIndex] === optionValue);
        }

        return variants.some((variant) => (
          variant.available &&
          variant.options[meta.optionIndex] === optionValue &&
          bundleVariantMatchesSelections(variant, selectedOptions, meta.optionIndex)
        ));
      };

      const setBundleButtonAvailability = (button, isAvailable) => {
        if (!(button instanceof HTMLButtonElement)) {
          return;
        }

        button.disabled = !isAvailable;
        button.setAttribute("aria-disabled", String(!isAvailable));
        button.classList.toggle("is-disabled", !isAvailable);
        button.classList.toggle("is-sold-out", !isAvailable);
        button.classList.remove("is-low-stock");

        if (!isAvailable) {
          button.setAttribute("aria-pressed", "false");
          button.classList.remove("is-selected");
        }
      };

      const closeBundleCustomSelect = (customSelect) => {
        if (!(customSelect instanceof HTMLElement)) {
          return;
        }

        const trigger = customSelect.querySelector("[data-bundle-custom-trigger]");
        const bundleCard = customSelect.closest("[data-bundle-item]");
        customSelect.classList.remove("is-open");
        bundleCard?.classList.remove("is-dropdown-open");
        if (trigger instanceof HTMLButtonElement) {
          trigger.setAttribute("aria-expanded", "false");
        }
      };

      const closeOtherBundleCustomSelects = (currentCustomSelect = null) => {
        document.querySelectorAll("[data-bundle-custom-select].is-open").forEach((customSelect) => {
          if (customSelect !== currentCustomSelect) {
            closeBundleCustomSelect(customSelect);
          }
        });
      };

      const syncBundleCustomSelect = (select) => {
        if (!(select instanceof HTMLSelectElement)) {
          return;
        }

        const shell = select.closest("[data-bundle-select-shell]");
        const customSelect = shell?.querySelector("[data-bundle-custom-select]");
        const trigger = customSelect?.querySelector("[data-bundle-custom-trigger]");
        const valueText = customSelect?.querySelector("[data-bundle-custom-value]");
        const menu = customSelect?.querySelector("[data-bundle-custom-menu]");

        if (!(customSelect instanceof HTMLElement) || !(trigger instanceof HTMLButtonElement) || !(valueText instanceof HTMLElement) || !(menu instanceof HTMLElement)) {
          return;
        }

        const selectedOption = select.selectedOptions[0] || select.options[0];
        valueText.textContent = selectedOption?.textContent || "Choose option...";
        trigger.classList.toggle("is-placeholder", !select.value);
        trigger.setAttribute("aria-activedescendant", select.value ? `${select.id}-custom-${select.selectedIndex}` : "");
        menu.innerHTML = "";

        Array.from(select.options).forEach((option, optionIndex) => {
          if (!option.value) {
            return;
          }

          const optionButton = document.createElement("button");
          optionButton.type = "button";
          optionButton.className = "bundle-custom-option";
          optionButton.id = `${select.id}-custom-${optionIndex}`;
          optionButton.setAttribute("role", "option");
          optionButton.setAttribute("aria-selected", String(option.value === select.value));
          optionButton.disabled = option.disabled;
          optionButton.setAttribute("aria-disabled", String(option.disabled));
          optionButton.classList.toggle("is-selected", option.value === select.value);
          optionButton.classList.toggle("is-disabled", option.disabled);
          optionButton.classList.toggle("is-sold-out", option.disabled);
          optionButton.textContent = option.textContent || option.value;

          optionButton.addEventListener("click", () => {
            if (optionButton.disabled) {
              return;
            }

            select.value = option.value;
            select.dispatchEvent(new Event("change", { bubbles: true }));
            closeBundleCustomSelect(customSelect);
            trigger.focus();
          });

          menu.append(optionButton);
        });
      };

      const initBundleCustomSelect = (select) => {
        if (!(select instanceof HTMLSelectElement) || select.dataset.bundleCustomBound === "true") {
          syncBundleCustomSelect(select);
          return;
        }

        const customSelect = select.closest("[data-bundle-select-shell]")?.querySelector("[data-bundle-custom-select]");
        const trigger = customSelect?.querySelector("[data-bundle-custom-trigger]");
        const menu = customSelect?.querySelector("[data-bundle-custom-menu]");

        if (!(customSelect instanceof HTMLElement) || !(trigger instanceof HTMLButtonElement) || !(menu instanceof HTMLElement)) {
          return;
        }

        select.dataset.bundleCustomBound = "true";
        trigger.setAttribute("aria-haspopup", "listbox");
        trigger.setAttribute("aria-expanded", "false");
        menu.setAttribute("role", "listbox");

        trigger.addEventListener("click", () => {
          const isOpen = customSelect.classList.contains("is-open");
          const bundleCard = customSelect.closest("[data-bundle-item]");
          closeOtherBundleCustomSelects(customSelect);
          customSelect.classList.toggle("is-open", !isOpen);
          bundleCard?.classList.toggle("is-dropdown-open", !isOpen);
          trigger.setAttribute("aria-expanded", String(!isOpen));
          if (!isOpen) {
            syncBundleCustomSelect(select);
          }
        });

        trigger.addEventListener("keydown", (event) => {
          if (event.key === "Escape") {
            closeBundleCustomSelect(customSelect);
            return;
          }

          if (event.key === "ArrowDown" || event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            closeOtherBundleCustomSelects(customSelect);
            customSelect.classList.add("is-open");
            customSelect.closest("[data-bundle-item]")?.classList.add("is-dropdown-open");
            trigger.setAttribute("aria-expanded", "true");
            syncBundleCustomSelect(select);
            const firstOption = menu.querySelector(".bundle-custom-option:not(:disabled)");
            if (firstOption instanceof HTMLButtonElement) {
              firstOption.focus();
            }
          }
        });

        menu.addEventListener("keydown", (event) => {
          const options = Array.from(menu.querySelectorAll(".bundle-custom-option:not(:disabled)"));
          const currentIndex = options.indexOf(document.activeElement);

          if (event.key === "Escape") {
            closeBundleCustomSelect(customSelect);
            trigger.focus();
            return;
          }

          if (event.key === "ArrowDown" || event.key === "ArrowUp") {
            event.preventDefault();
            const direction = event.key === "ArrowDown" ? 1 : -1;
            const nextOption = options[(currentIndex + direction + options.length) % options.length];
            if (nextOption instanceof HTMLButtonElement) {
              nextOption.focus();
            }
          }
        });

        syncBundleCustomSelect(select);
      };

      const syncBundleOptionAvailability = (item, variants) => {
        if (!(item instanceof HTMLElement) || !Array.isArray(variants) || !variants.length) {
          return [];
        }

        const optionMeta = getBundleOptionMeta(item);
        const hadAnySelection = readBundleSelectedOptions(optionMeta).some(Boolean);

        for (let pass = 0; pass < 2; pass += 1) {
          const selectedOptions = readBundleSelectedOptions(optionMeta);

          optionMeta.forEach((meta) => {
            const select = meta.group.querySelector("select[data-bundle-select]");
            if (select instanceof HTMLSelectElement) {
              Array.from(select.options).forEach((option) => {
                if (!option.value) {
                  return;
                }

                if (!option.dataset.bundleOptionLabel) {
                  option.dataset.bundleOptionLabel = option.textContent?.replace(/\s*·\s*Sold out$/i, "") || option.value;
                }

                const isAvailable = isBundleOptionValueAvailable(variants, meta, option.value, selectedOptions);
                option.disabled = !isAvailable;
                option.textContent = isAvailable ? option.dataset.bundleOptionLabel : `${option.dataset.bundleOptionLabel} · Sold out`;
              });

              if (select.value && select.selectedOptions[0]?.disabled) {
                select.value = "";
              }
              syncBundleCustomSelect(select);
              return;
            }

            meta.group.querySelectorAll("[data-option-value]").forEach((button) => {
              const optionValue = button.getAttribute("data-option-value") || "";
              setBundleButtonAvailability(button, isBundleOptionValueAvailable(variants, meta, optionValue, selectedOptions));
            });
          });

          const shouldAutoSelect = hadAnySelection;
          optionMeta.forEach((meta) => {
            const select = meta.group.querySelector("select[data-bundle-select]");
            if (select instanceof HTMLSelectElement) {
              if (!select.value && shouldAutoSelect) {
                const firstAvailableOption = Array.from(select.options).find((option) => option.value && !option.disabled);
                if (firstAvailableOption) {
                  select.value = firstAvailableOption.value;
                }
              }
              syncBundleCustomSelect(select);
              return;
            }

            const selectedButton = meta.group.querySelector("[aria-pressed='true']:not(:disabled)");
            if (!selectedButton && shouldAutoSelect) {
              const firstAvailableButton = meta.group.querySelector("[data-option-value]:not(:disabled)");
              if (firstAvailableButton instanceof HTMLButtonElement) {
                setSelectedBundleButton(firstAvailableButton);
              }
            }
          });
        }

        return readBundleSelectedOptions(optionMeta);
      };

      const setSelectedBundleButton = (button) => {
        if (!(button instanceof HTMLButtonElement) || button.disabled) {
          return;
        }

        const optionPosition = button.getAttribute("data-option-position");
        const group = button.closest("[data-bundle-option-group]");
        if (!optionPosition || !(group instanceof HTMLElement)) {
          return;
        }

        group.querySelectorAll("[data-option-value]").forEach((candidate) => {
          const isActive = candidate === button && !candidate.disabled;
          candidate.setAttribute("aria-pressed", String(isActive));
          candidate.classList.toggle("is-selected", isActive);
        });
      };

      const syncBaseItem = () => {
        const baseItem = bundle.querySelector("[data-bundle-base]");
        const basePriceInput = baseItem?.querySelector("[data-bundle-price-cents]");
        const baseVariantIdInput = baseItem?.querySelector("[data-bundle-variant-id]");
        const basePriceLabel = baseItem?.querySelector("[data-bundle-item-price]");
        const activeVariant = getActiveBaseVariant();

        if (!(baseItem instanceof HTMLElement) || !(basePriceInput instanceof HTMLInputElement) || !(baseVariantIdInput instanceof HTMLInputElement) || !(basePriceLabel instanceof HTMLElement)) {
          return null;
        }

        const fallbackCents = Number(baseItem.getAttribute("data-initial-price-cents")) || 0;
        const nextPrice = Number(activeVariant?.price) || fallbackCents;
        basePriceInput.value = String(nextPrice);
        baseVariantIdInput.value = activeVariant ? String(activeVariant.id) : "";
        basePriceLabel.textContent = activeVariant?.price_money || formatMoney(nextPrice);
        syncBaseBundleImage(baseItem, activeVariant);
        return activeVariant;
      };

      const syncBundleItem = (item) => {
        if (!(item instanceof HTMLElement)) {
          return { complete: true, available: true, priceCents: 0, variantId: "", autoExclude: false };
        }

        if (item.hidden || item.getAttribute("data-bundle-excluded") === "true") {
          return { complete: true, available: true, priceCents: 0, variantId: "", autoExclude: false };
        }

        const variantIdInput = item.querySelector("[data-bundle-variant-id]");
        const priceInput = item.querySelector("[data-bundle-price-cents]");
        const priceLabel = item.querySelector("[data-bundle-item-price]");
        const errorLabel = item.querySelector("[data-bundle-item-error]");
        const stockLabel = item.querySelector("[data-bundle-item-stock]");
        const fallbackPrice = Number(item.getAttribute("data-initial-price-cents")) || 0;
        const variantScript = item.querySelector("[data-bundle-variants]");
        const optionGroups = Array.from(item.querySelectorAll("[data-bundle-option-group]"));

        if (!(variantIdInput instanceof HTMLInputElement) || !(priceInput instanceof HTMLInputElement) || !(priceLabel instanceof HTMLElement)) {
          return { complete: true, available: true, priceCents: fallbackPrice, variantId: "", autoExclude: false };
        }

        if (item.getAttribute("data-bundle-load-failed") === "true") {
          variantIdInput.value = "";
          if (stockLabel instanceof HTMLElement) {
            stockLabel.className = "bundle-item-stock is-low-stock";
            stockLabel.textContent = "Options unavailable for this item.";
          }
          if (errorLabel instanceof HTMLElement) {
            errorLabel.textContent = "This bundle item can’t be configured right now.";
          }
          return { complete: true, available: false, priceCents: fallbackPrice, variantId: "", autoExclude: true };
        }

        if (!variantScript || !optionGroups.length) {
          const variantId = variantIdInput.value;
          const priceCents = Number(priceInput.value) || fallbackPrice;
          const activeVariant = getItemVariantData(item, variantId);
          updateBundleItemImage(item, activeVariant);
          if (stockLabel instanceof HTMLElement) {
            const isSingleVariant = item.getAttribute("data-bundle-single-variant") === "true";
            stockLabel.className = `bundle-item-stock ${variantId ? "is-ready" : "is-pending"}`;
            stockLabel.textContent = variantId
              ? (isSingleVariant ? "Included as shown." : "Ready to add.")
              : "Please choose options.";
          }
          if (errorLabel instanceof HTMLElement && variantId) {
            errorLabel.textContent = "";
          }
          return { complete: true, available: true, priceCents, variantId, autoExclude: false };
        }

        let variants = [];
        try {
          variants = JSON.parse(variantScript.textContent || "[]");
        } catch (_error) {}

        const selectedOptions = syncBundleOptionAvailability(item, variants);
        const missingSelections = variants[0]?.options?.some((_value, index) => !selectedOptions[index]);
        const matchingVariants = variants.filter((variant) =>
          variant.options.every((value, index) => !selectedOptions[index] || value === selectedOptions[index])
        );
        const matchedVariant = !missingSelections
          ? matchingVariants.find((variant) => variant.options.every((value, index) => value === selectedOptions[index]))
          : null;

        if (missingSelections) {
          variantIdInput.value = "";
          priceInput.value = String(fallbackPrice);
          priceLabel.textContent = formatMoney(fallbackPrice);
          if (stockLabel instanceof HTMLElement) {
            stockLabel.className = "bundle-item-stock is-pending";
            stockLabel.textContent = "Please choose options.";
          }
          if (errorLabel instanceof HTMLElement) {
            errorLabel.textContent = "";
          }
          return { complete: false, available: false, priceCents: fallbackPrice, variantId: "", autoExclude: false };
        }

        if (!matchedVariant) {
          variantIdInput.value = "";
          priceInput.value = String(fallbackPrice);
          priceLabel.textContent = formatMoney(fallbackPrice);
          if (stockLabel instanceof HTMLElement) {
            stockLabel.className = "bundle-item-stock is-low-stock";
            stockLabel.textContent = matchingVariants.length ? "This combination isn’t available." : "This combination is unavailable.";
          }
          if (errorLabel instanceof HTMLElement) {
            errorLabel.textContent = "Choose a valid size and colour combination.";
          }
          return {
            complete: true,
            available: false,
            priceCents: fallbackPrice,
            variantId: "",
            autoExclude: selectedOptions.every((value) => !value)
          };
        }

        variantIdInput.value = matchedVariant.available ? String(matchedVariant.id) : "";
        priceInput.value = String(matchedVariant.price);
        priceLabel.textContent = matchedVariant.price_money;
        updateBundleItemImage(item, matchedVariant);
        if (stockLabel instanceof HTMLElement) {
          stockLabel.className = `bundle-item-stock ${matchedVariant.available ? "is-ready" : "is-low-stock"}`;
          stockLabel.textContent = matchedVariant.available ? "Ready to add." : "Sold out.";
        }
        if (errorLabel instanceof HTMLElement) {
          errorLabel.textContent = matchedVariant.available ? "" : "This option is sold out.";
        }
        return {
          complete: true,
          available: Boolean(matchedVariant.available),
          priceCents: Number(matchedVariant.price) || fallbackPrice,
          variantId: matchedVariant.available ? String(matchedVariant.id) : "",
          autoExclude: false
        };
      };

      const applyRenderedSwatches = (scope) => {
        if (!(scope instanceof HTMLElement)) {
          return;
        }

        scope.querySelectorAll("[data-swatch]").forEach((swatch) => {
          applySwatchBackground(swatch);
        });
      };

      const closeBundleModal = () => {
        pendingBundleItems = [];
        pendingBundleIndex = 0;
        if (modalRoot instanceof HTMLElement) {
          modalRoot.hidden = true;
        }
        if (modalBody instanceof HTMLElement) {
          modalBody.innerHTML = "";
        }
      };

      const syncModalConfirmState = (item) => {
        if (!(item instanceof HTMLElement) || !(modalConfirm instanceof HTMLButtonElement)) {
          return;
        }

        const variantIdInput = item.querySelector("[data-bundle-variant-id]");
        const hasVariant = variantIdInput instanceof HTMLInputElement && Boolean(variantIdInput.value);
        modalConfirm.disabled = !hasVariant;
        modalConfirm.textContent = pendingBundleIndex === pendingBundleItems.length - 1 ? "Add Bundle to Bag" : "Confirm";

        if (modalError instanceof HTMLElement) {
          modalError.textContent = hasVariant ? "" : "Select colour and size to continue.";
        }
      };

      if (bundle.dataset.bundleCustomSelectCloseBound !== "true") {
        bundle.dataset.bundleCustomSelectCloseBound = "true";
        document.addEventListener("click", (event) => {
          if (!(event.target instanceof Element) || event.target.closest("[data-bundle-custom-select]")) {
            return;
          }

          closeOtherBundleCustomSelects();
        });
      }

      const renderBundleModal = () => {
        const item = pendingBundleItems[pendingBundleIndex];
        if (!(item instanceof HTMLElement) || !(modalRoot instanceof HTMLElement) || !(modalBody instanceof HTMLElement)) {
          return;
        }

        modalRoot.hidden = false;
        modalBody.innerHTML = "";

        if (modalTitle instanceof HTMLElement) {
          modalTitle.textContent = `Choose options for ${item.getAttribute("data-product-title") || "this item"}`;
        }

        if (modalPrice instanceof HTMLElement) {
          modalPrice.textContent = item.querySelector("[data-bundle-item-price]")?.textContent || "";
        }

        if (modalProgress instanceof HTMLElement) {
          modalProgress.textContent = `Item ${pendingBundleIndex + 1} of ${pendingBundleItems.length}`;
        }

        if (modalImage instanceof HTMLElement) {
          modalImage.innerHTML = item.querySelector(".bundle-item-image")?.innerHTML || "";
        }

        const variantScript = item.querySelector("[data-bundle-variants]");
        if (variantScript) {
          try {
            syncBundleOptionAvailability(item, JSON.parse(variantScript.textContent || "[]"));
          } catch (_error) {}
        }

        const selectorClone = item.querySelector(".bundle-item-selectors")?.cloneNode(true);
        if (!(selectorClone instanceof HTMLElement)) {
          syncModalConfirmState(item);
          return;
        }

        selectorClone.querySelectorAll("[data-option-value]").forEach((cloneButton) => {
          const optionPosition = cloneButton.getAttribute("data-option-position");
          const optionValue = cloneButton.getAttribute("data-option-value") || "";
          const originalButton = Array.from(
            item.querySelectorAll(`[data-bundle-option-group][data-option-position='${optionPosition}'] [data-option-value]`)
          ).find((candidate) => candidate.getAttribute("data-option-value") === optionValue);

          if (!(originalButton instanceof HTMLButtonElement)) {
            return;
          }

          cloneButton.classList.toggle("is-selected", originalButton.getAttribute("aria-pressed") === "true");
          cloneButton.setAttribute("aria-pressed", originalButton.getAttribute("aria-pressed") || "false");
          cloneButton.disabled = originalButton.disabled;
          cloneButton.setAttribute("aria-disabled", String(originalButton.disabled));
          cloneButton.classList.toggle("is-disabled", originalButton.disabled);
          cloneButton.classList.toggle("is-sold-out", originalButton.disabled);
          cloneButton.classList.remove("is-low-stock");

          cloneButton.addEventListener("click", () => {
            if (cloneButton.disabled) {
              return;
            }

            item.setAttribute("data-bundle-touched", "true");
            setSelectedBundleButton(originalButton);

            const cloneGroup = cloneButton.closest("[data-bundle-option-group]");
            cloneGroup?.querySelectorAll("[data-option-value]").forEach((candidate) => {
              const isActive = candidate === cloneButton;
              candidate.setAttribute("aria-pressed", String(isActive));
              candidate.classList.toggle("is-selected", isActive);
            });

            syncBundleState();
            syncModalConfirmState(item);
            if (pendingBundleItems[pendingBundleIndex] === item) {
              renderBundleModal();
            }
          });
        });

        selectorClone.querySelectorAll("select[data-bundle-select]").forEach((cloneSel) => {
          const pos = cloneSel.dataset.optionPosition;
          const origSel = item.querySelector(`select[data-bundle-select][data-option-position="${pos}"]`);
          if (!(origSel instanceof HTMLSelectElement) || !(cloneSel instanceof HTMLSelectElement)) return;
          cloneSel.value = origSel.value;
          delete cloneSel.dataset.bundleCustomBound;
          initBundleCustomSelect(cloneSel);
          syncBundleCustomSelect(cloneSel);
          cloneSel.addEventListener("change", () => {
            if (cloneSel.selectedOptions[0]?.disabled) {
              cloneSel.value = origSel.value;
              syncBundleCustomSelect(cloneSel);
              return;
            }
            item.setAttribute("data-bundle-touched", "true");
            origSel.value = cloneSel.value;
            syncBundleState();
            syncModalConfirmState(item);
            if (pendingBundleItems[pendingBundleIndex] === item) {
              renderBundleModal();
            }
          });
        });

        modalBody.append(selectorClone);
        applyRenderedSwatches(modalBody);
        syncBundleState();
        syncModalConfirmState(item);
      };

      const syncBundleState = () => {
        const hasPendingFetches = getActiveBundleItems().some(
          (item) => item instanceof HTMLElement && !item.hasAttribute("data-bundle-base") && item.hasAttribute("data-bundle-fetching")
        );
        if (hasPendingFetches) {
          bundleAddButton.disabled = true;
          bundleAddButton.textContent = "Loading options…";
          clearBundleFeedback();
          return;
        }

        const activeBaseVariant = syncBaseItem();
        const activeItems = getActiveBundleItems();
        const baseSelectionIncomplete = isBaseSelectionIncomplete();

        let originalTotal = Number(activeBaseVariant?.price) || 0;
        let hasInlineMissingSelections = false;
        let hasModalPendingSelections = false;
        let hasUnavailableItem = !baseSelectionIncomplete && activeBaseVariant ? activeBaseVariant.available === false : false;

        activeItems.forEach((item) => {
          if (!(item instanceof HTMLElement) || item.hasAttribute("data-bundle-base")) {
            return;
          }

          const state = syncBundleItem(item);

          if (
            state.complete &&
            !state.available &&
            (state.autoExclude || item.getAttribute("data-bundle-touched") !== "true")
          ) {
            excludeBundleItem(item);
            return;
          }

          originalTotal += state.priceCents;

          if (
            item.hasAttribute("data-bundle-requires-options") &&
            (!state.complete || !state.variantId)
          ) {
            if (item.querySelector("select[data-bundle-select]")) {
              hasInlineMissingSelections = true;
            } else {
              hasModalPendingSelections = true;
            }
          }
        });

        const rawDiscounted = Math.round(originalTotal * ((100 - discountPercent) / 100));
        const finalPrice = roundBundlePrice(rawDiscounted);
        const saving = Math.max(0, originalTotal - finalPrice);

        if (originalPriceText instanceof HTMLElement) {
          originalPriceText.textContent = formatMoney(originalTotal);
        }

        if (discountedPriceText instanceof HTMLElement) {
          discountedPriceText.textContent = formatMoney(finalPrice);
        }

        if (savingText instanceof HTMLElement) {
          savingText.textContent = `You save: ${formatMoney(saving)} (${discountPercent}% off)`;
        }

        if (baseSelectionIncomplete) {
          bundleAddButton.disabled = true;
          bundleAddButton.textContent = "Choose base options";
          if (bundleError instanceof HTMLElement) {
            bundleError.textContent = "Choose size and colour for the base product first.";
          }
          if (bundleSuccess instanceof HTMLElement) {
            bundleSuccess.hidden = true;
          }
          return;
        }

        if (hasUnavailableItem) {
          bundleAddButton.disabled = true;
          bundleAddButton.textContent = "Unavailable";
          if (bundleError instanceof HTMLElement) {
            bundleError.textContent = "The selected base product variant is sold out.";
          }
          if (bundleSuccess instanceof HTMLElement) {
            bundleSuccess.hidden = true;
          }
          return;
        }

        if (isSubmittingBundle) {
          bundleAddButton.disabled = true;
          bundleAddButton.textContent = "Adding...";
          return;
        }

        if (hasInlineMissingSelections) {
          bundleAddButton.disabled = true;
          bundleAddButton.textContent = "Choose options";
          if (bundleError instanceof HTMLElement) {
            bundleError.textContent = "Select an in-stock option for each bundle item.";
          }
          return;
        }

        if (hasModalPendingSelections) {
          bundleAddButton.disabled = true;
          bundleAddButton.textContent = "Choose options";
          if (bundleError instanceof HTMLElement) {
            bundleError.textContent = "Select an in-stock option for each bundle item.";
          }
          return;
        }

        bundleAddButton.disabled = false;
        bundleAddButton.textContent = "Add Bundle to Bag";
        if (bundleError instanceof HTMLElement) {
          bundleError.textContent = "";
        }
      };

      bundleItems.forEach((item) => {
        if (!(item instanceof HTMLElement)) {
          return;
        }

        item.querySelectorAll("[data-bundle-option-group] [data-option-value]").forEach((button) => {
          button.addEventListener("click", () => {
            if (button.disabled) {
              return;
            }

            item.setAttribute("data-bundle-touched", "true");
            setSelectedBundleButton(button);
            syncBundleState();
          });
        });

      });

      modalRoot?.querySelectorAll("[data-bundle-modal-close]").forEach((button) => {
        button.addEventListener("click", () => {
          closeBundleModal();
        });
      });

      productForm?.querySelectorAll("[data-option-value]").forEach((button) => {
        button.addEventListener("click", () => {
          window.requestAnimationFrame(() => {
            syncBundleState();
          });
        });
      });

      bundleAddButton.addEventListener("click", async () => {
        clearBundleFeedback();
        syncBundleState();
        if (bundleAddButton.disabled) {
          return;
        }

        if (isBaseSelectionIncomplete()) {
          if (bundleError instanceof HTMLElement) {
            bundleError.textContent = "Choose size and colour for the base product first.";
          }
          if (baseAddToCartButton instanceof HTMLElement) {
            baseAddToCartButton.scrollIntoView({ behavior: "smooth", block: "nearest" });
          }
          return;
        }

        // Items with inline <select> dropdowns: show per-item errors instead of opening modal
        const incompleteInline = getActiveBundleItems().filter((item) => {
          if (!(item instanceof HTMLElement) || item.hasAttribute("data-bundle-base") || !item.hasAttribute("data-bundle-requires-options")) return false;
          if (!item.querySelector("select[data-bundle-select]")) return false;
          const variantInput = item.querySelector("[data-bundle-variant-id]");
          return !(variantInput instanceof HTMLInputElement) || !variantInput.value;
        });

        if (incompleteInline.length) {
          incompleteInline.forEach((item) => {
            const errorEl = item.querySelector("[data-bundle-item-error]");
            const stockEl = item.querySelector("[data-bundle-item-stock]");
            if (errorEl instanceof HTMLElement) errorEl.textContent = "Please choose your options above.";
            if (stockEl instanceof HTMLElement) {
              stockEl.className = "bundle-item-stock is-pending";
              stockEl.textContent = "Please choose options.";
            }
          });
          if (bundleError instanceof HTMLElement) {
            bundleError.textContent = "Select size and colour for each bundle item before adding.";
          }
          incompleteInline[0].scrollIntoView({ behavior: "smooth", block: "nearest" });
          return;
        }

        // Items using button-based selectors (modal flow)
        const unresolvedItems = getActiveBundleItems().filter((item) => {
          if (!(item instanceof HTMLElement) || item.hasAttribute("data-bundle-base") || !item.hasAttribute("data-bundle-requires-options")) {
            return false;
          }
          if (item.querySelector("select[data-bundle-select]")) return false;
          const variantIdInput = item.querySelector("[data-bundle-variant-id]");
          return !(variantIdInput instanceof HTMLInputElement) || !variantIdInput.value;
        });

        if (unresolvedItems.length) {
          pendingBundleItems = unresolvedItems;
          pendingBundleIndex = 0;
          renderBundleModal();
          return;
        }

        const itemsToAdd = [];
        const lineItems = [];
        const baseVariant = getActiveBaseVariant();
        const bundleToken = `bundle-${Date.now()}-${Math.round(Math.random() * 100000)}`;
        const bundleDiscountPercentString = String(discountPercent);
        const bundleLabel = "Full outfit bundle";
        const expectedBundleCount = getActiveBundleItems().filter((item) => item instanceof HTMLElement).length;
        let bundleComponentIndex = 1;

        if (baseVariant?.available) {
          itemsToAdd.push({
            id: baseVariant.id,
            quantity: 1,
            properties: {
              _bundle_id: bundleToken,
              _bundle_name: bundleLabel,
              _bundle_label: bundleLabel,
              _bundle_required_count: String(expectedBundleCount),
              _bundle_item_count: String(expectedBundleCount),
              _bundle_discount: bundleDiscountPercentString,
              _bundle_discount_percent: bundleDiscountPercentString,
              _bundle_component: `component-${bundleComponentIndex}`,
              _bundle_role: "base"
            }
          });
          bundleComponentIndex += 1;
          lineItems.push({
            title: bundle.querySelector("[data-bundle-base]")?.getAttribute("data-product-title") || productForm?.closest(".purchase-panel")?.querySelector("h1")?.textContent || "Base product",
            summary: buildVariantSummary(baseVariant)
          });
        }

        bundleItems.forEach((item) => {
          if (!(item instanceof HTMLElement) || item.hasAttribute("data-bundle-base")) {
            return;
          }

          const variantIdInput = item.querySelector("[data-bundle-variant-id]");
          if (!(variantIdInput instanceof HTMLInputElement) || !variantIdInput.value) {
            return;
          }

          const nextVariantId = Number(variantIdInput.value);
          const variantData = getItemVariantData(item, nextVariantId);
          if (!variantData?.available) {
            const errorEl = item.querySelector("[data-bundle-item-error]");
            const stockEl = item.querySelector("[data-bundle-item-stock]");
            if (errorEl instanceof HTMLElement) errorEl.textContent = "Choose an in-stock option for this bundle item.";
            if (stockEl instanceof HTMLElement) {
              stockEl.className = "bundle-item-stock is-low-stock";
              stockEl.textContent = "Sold out.";
            }
            return;
          }

          itemsToAdd.push({
            id: nextVariantId,
            quantity: 1,
            properties: {
              _bundle_id: bundleToken,
              _bundle_name: bundleLabel,
              _bundle_label: bundleLabel,
              _bundle_required_count: String(expectedBundleCount),
              _bundle_item_count: String(expectedBundleCount),
              _bundle_discount: bundleDiscountPercentString,
              _bundle_discount_percent: bundleDiscountPercentString,
              _bundle_component: `component-${bundleComponentIndex}`,
              _bundle_role: "item"
            }
          });
          bundleComponentIndex += 1;
          lineItems.push({
            title: item.getAttribute("data-product-title") || "Bundle item",
            summary: buildVariantSummary(variantData)
          });
        });

        if (!itemsToAdd.length || itemsToAdd.length !== expectedBundleCount) {
          if (bundleError instanceof HTMLElement) {
            bundleError.textContent = "Select each bundle item before adding it to bag.";
          }
          return;
        }

        isSubmittingBundle = true;
        syncBundleState();
        let addSucceeded = false;

        try {
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ items: itemsToAdd })
          });

          if (!response.ok) {
            let errorMessage = "We couldn't add the bundle just now. Please try again.";
            try {
              const payload = await response.json();
              errorMessage = payload.description || payload.message || errorMessage;
            } catch (_error) {}
            throw new Error(errorMessage);
          }

          addSucceeded = true;
          const shouldRefreshCartPage = document.body.classList.contains("cart-page");
          const sectionNames = ["header", "cart-drawer"];
          try {
            await refreshSections(sectionNames, "/");
            if (shouldRefreshCartPage) {
              await refreshCartPageContent();
            }
            initCartDrawer();
          } catch (refreshError) {
            if (!(refreshError instanceof DOMException && refreshError.name === "AbortError")) {
              console.warn("Cart refresh failed after bundle add; falling back to cart JSON.", refreshError);
            }

            try {
              const fallbackCart = await fetchCartJson();
              syncCartFallbackDisplay(fallbackCart);
            } catch (cartError) {
              console.warn("Cart JSON fallback failed after bundle add.", cartError);
            }

            if (shouldRefreshCartPage) {
              window.location.reload();
              return;
            }
          }
          renderBundleSuccess(lineItems);
          setCartDrawerOpen(true);
        } catch (error) {
          if (!addSucceeded && bundleError instanceof HTMLElement) {
            bundleError.textContent = error instanceof Error ? error.message : "We couldn't add the bundle just now. Please try again.";
          }
        } finally {
          isSubmittingBundle = false;
          syncBundleState();
        }
      });

      modalConfirm?.addEventListener("click", () => {
        const currentItem = pendingBundleItems[pendingBundleIndex];
        if (!(currentItem instanceof HTMLElement)) {
          closeBundleModal();
          return;
        }

        const variantIdInput = currentItem.querySelector("[data-bundle-variant-id]");
        if (!(variantIdInput instanceof HTMLInputElement) || !variantIdInput.value) {
          syncModalConfirmState(currentItem);
          return;
        }

        if (pendingBundleIndex < pendingBundleItems.length - 1) {
          pendingBundleIndex += 1;
          renderBundleModal();
          return;
        }

        closeBundleModal();
        bundleAddButton.click();
      });

      syncBundleState();

      // Dynamically fetch and render inline variant selectors for each non-base bundle item
      const fetchBundleItemOptions = async (item) => {
        const handle = item.dataset.productHandle;
        const container = item.querySelector("[data-bundle-selectors-container]");
        if (!handle || !(container instanceof HTMLElement)) return;

        item.setAttribute("data-bundle-fetching", "true");
        item.removeAttribute("data-bundle-load-failed");
        syncBundleState();

        try {
          const resp = await fetch(`/products/${encodeURIComponent(handle)}.js`);
          if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
          const pd = await resp.json();
          const hasAnyAvailableVariant = Array.isArray(pd.variants) && pd.variants.some((variant) => variant.available);

          if (!hasAnyAvailableVariant) {
            excludeBundleItem(item);
            return;
          }

          // Store variant data so syncBundleItem can match selections to variant IDs
          let varScript = item.querySelector("[data-bundle-variants]");
          if (!varScript) {
            varScript = document.createElement("script");
            varScript.type = "application/json";
            varScript.setAttribute("data-bundle-variants", "");
            item.appendChild(varScript);
          }
          varScript.textContent = JSON.stringify(
            pd.variants.map((v) => ({
              id: v.id,
              available: v.available,
              price: v.price,
              price_money: formatMoney(v.price),
              title: v.title,
              options: v.options,
              featured_image_src: v.featured_image?.src || v.featured_image?.url || "",
              featured_image_alt: v.featured_image?.alt || pd.title || "",
              featured_media_src: v.featured_media?.preview_image?.src || v.featured_media?.src || "",
              featured_media_alt: v.featured_media?.alt || pd.title || ""
            }))
          );

          // Update displayed price to first available variant's price
          const firstAvail = pd.variants.find((v) => v.available) || pd.variants[0];
          if (firstAvail) {
            const priceInput = item.querySelector("[data-bundle-price-cents]");
            const priceLabel = item.querySelector("[data-bundle-item-price]");
            const stockLabel = item.querySelector("[data-bundle-item-stock]");
            if (priceInput instanceof HTMLInputElement) priceInput.value = String(firstAvail.price);
            if (priceLabel instanceof HTMLElement) priceLabel.textContent = formatMoney(firstAvail.price);
            updateBundleItemImage(item, {
              featured_image_src: firstAvail.featured_image?.src || firstAvail.featured_image?.url || "",
              featured_image_alt: firstAvail.featured_image?.alt || pd.title || "",
              featured_media_src: firstAvail.featured_media?.preview_image?.src || firstAvail.featured_media?.src || "",
              featured_media_alt: firstAvail.featured_media?.alt || pd.title || ""
            });
            if (stockLabel instanceof HTMLElement) {
              stockLabel.className = `bundle-item-stock ${firstAvail.available ? "is-pending" : "is-low-stock"}`;
              stockLabel.textContent = firstAvail.available ? "Please choose options." : "Sold out.";
            }
            if (!Number(item.getAttribute("data-initial-price-cents"))) {
              item.setAttribute("data-initial-price-cents", String(firstAvail.price));
            }
          }

          // Single default variant — no selectors needed, pre-set the variant ID
          const isDefaultOnly = pd.variants.length === 1 && pd.variants[0].title === "Default Title";
          if (isDefaultOnly) {
            item.removeAttribute("data-bundle-requires-options");
            item.setAttribute("data-bundle-single-variant", "true");
            const vidInput = item.querySelector("[data-bundle-variant-id]");
            const stockLabel = item.querySelector("[data-bundle-item-stock]");
            if (vidInput instanceof HTMLInputElement) vidInput.value = String(pd.variants[0].id);
            if (stockLabel instanceof HTMLElement) {
              stockLabel.className = `bundle-item-stock ${pd.variants[0].available ? "is-ready" : "is-low-stock"}`;
              stockLabel.textContent = pd.variants[0].available ? "Included as shown." : "Sold out.";
            }
            container.innerHTML = "<p class=\"bundle-item-summary\">Included as shown.</p>";
            return;
          }

          item.removeAttribute("data-bundle-single-variant");

          // Build inline <select> dropdown for each product option
          const html = pd.options
            .map((option, idx) => {
              const optName = typeof option === "string" ? option : option?.name || `Option ${idx + 1}`;
              const uniqueVals = [];
              pd.variants.forEach((v) => {
                if (!uniqueVals.includes(v.options[idx])) uniqueVals.push(v.options[idx]);
              });
              const uid = `bopt-${item.dataset.productId || handle}-${idx}`;
              const optEls = uniqueVals
                .map((val) => {
                  const avail = pd.variants.some((v) => v.options[idx] === val && v.available);
                  const safeVal = String(val).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
                  const safeLabel = String(val).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
                  const optionLabel = avail ? safeLabel : `${safeLabel} · Sold out`;
                  return `<option value="${safeVal}" data-bundle-option-label="${safeVal}"${avail ? "" : " disabled"}>${optionLabel}</option>`;
                })
                .join("");
              const optionLabelLower = String(optName).trim().toLowerCase();
              const placeholder = optionLabelLower.includes("color") || optionLabelLower.includes("colour")
                ? "Choose colour..."
                : optionLabelLower.includes("size")
                  ? "Choose size..."
                  : `Choose ${optName}...`;
              return (
                `<div class="bundle-item-option" data-bundle-option-group data-option-position="${idx + 1}" data-option-name="${String(optName).replace(/"/g, "&quot;")}">` +
                `<label class="bundle-option-label" for="${uid}">${optName}</label>` +
                `<div class="bundle-select-shell" data-bundle-select-shell>` +
                `<select id="${uid}" class="bundle-option-select" data-bundle-select data-option-position="${idx + 1}" data-option-name="${String(optName).replace(/"/g, "&quot;")}" tabindex="-1" aria-hidden="true">` +
                `<option value="">${placeholder}</option>${optEls}</select>` +
                `<div class="bundle-custom-select" data-bundle-custom-select>` +
                `<button class="bundle-custom-trigger" type="button" data-bundle-custom-trigger aria-controls="${uid}-custom-menu">` +
                `<span data-bundle-custom-value>${placeholder}</span><span class="bundle-custom-caret" aria-hidden="true"></span></button>` +
                `<div id="${uid}-custom-menu" class="bundle-custom-menu" data-bundle-custom-menu></div>` +
                `</div></div></div>`
              );
            })
            .join("");

          container.innerHTML = html;

          container.querySelectorAll("select[data-bundle-select]").forEach((sel) => {
            sel.selectedIndex = 0;
            initBundleCustomSelect(sel);
            sel.addEventListener("change", () => {
              if (sel.selectedOptions[0]?.disabled) {
                sel.value = "";
                syncBundleCustomSelect(sel);
                return;
              }
              item.setAttribute("data-bundle-touched", "true");
              const itemError = item.querySelector("[data-bundle-item-error]");
              if (itemError instanceof HTMLElement) {
                itemError.textContent = "";
              }
              syncBundleState();
            });
          });
        } catch (_err) {
          container.innerHTML = "<p class=\"bundle-item-summary\">Options couldn’t be loaded.</p>";
          item.setAttribute("data-bundle-load-failed", "true");
          const vidInput = item.querySelector("[data-bundle-variant-id]");
          const stockLabel = item.querySelector("[data-bundle-item-stock]");
          if (vidInput instanceof HTMLInputElement) vidInput.value = "";
          if (stockLabel instanceof HTMLElement) {
            stockLabel.className = "bundle-item-stock is-low-stock";
            stockLabel.textContent = "Options unavailable for this item.";
          }
        } finally {
          item.removeAttribute("data-bundle-fetching");
          syncBundleState();
        }
      };

      bundleItems.forEach((item) => {
        if (item instanceof HTMLElement && !item.hasAttribute("data-bundle-base")) {
          fetchBundleItemOptions(item);
        }
      });

      dedupeRenderedBundleItems();
      syncBundleState();
    });
  };

  const initProductAccordions = () => {
    document.querySelectorAll(".product-accordion").forEach((accordion) => {
      if (!(accordion instanceof HTMLElement) || accordion.dataset.accordionBound === "true") {
        return;
      }

      accordion.dataset.accordionBound = "true";

      accordion.querySelectorAll(".product-accordion-item").forEach((item) => {
        if (!(item instanceof HTMLDetailsElement)) {
          return;
        }

        const summary = item.querySelector("summary");
        const content = item.querySelector(".product-accordion-content");
        if (!(summary instanceof HTMLElement) || !(content instanceof HTMLElement)) {
          return;
        }

        let accordionAnimation = null;
        const isMobileAccordion = () => window.matchMedia("(max-width: 820px)").matches;
        const prefersReducedAccordionMotion = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (item.open) {
          item.classList.add("is-open");
        }

        const finishAnimation = (open) => {
          if (!open) {
            item.open = false;
          }

          accordionAnimation = null;
          item.dataset.accordionAnimating = "false";
          item.classList.toggle("is-open", open);
          item.classList.remove("is-animating", "is-opening", "is-closing");
          content.style.overflow = "";
          content.style.height = "";
          content.style.opacity = "";
          content.style.transform = "";
          content.style.transition = "";
          content.style.willChange = "";
        };

        const getAnimationDuration = (startHeight, targetHeight, opening) => {
          const distance = Math.abs(targetHeight - startHeight);
          if (isMobileAccordion()) {
            const mobileBaseDuration = opening ? 150 : 125;
            const mobileMaxDuration = opening ? 210 : 170;
            return Math.min(mobileMaxDuration, Math.max(mobileBaseDuration, Math.round(mobileBaseDuration + distance * 0.18)));
          }
          const baseDuration = opening ? 170 : 140;
          const maxDuration = opening ? 260 : 210;
          return Math.min(maxDuration, Math.max(baseDuration, Math.round(baseDuration + distance * 0.28)));
        };

        const animateAccordion = (open) => {
          const wasOpen = item.open;
          const currentHeight = wasOpen || accordionAnimation ? content.getBoundingClientRect().height : 0;

          if (accordionAnimation) {
            accordionAnimation.cancel();
            accordionAnimation = null;
          }

          if (!open && !wasOpen && currentHeight <= 0) {
            return;
          }

          if (prefersReducedAccordionMotion()) {
            item.open = open;
            finishAnimation(open);
            return;
          }

          if (isMobileAccordion()) {
            const duration = 200;
            let fallbackTimer = null;

            item.dataset.accordionAnimating = "true";
            item.classList.add("is-animating");
            item.classList.remove(open ? "is-closing" : "is-opening");
            item.classList.add(open ? "is-opening" : "is-closing");
            content.style.setProperty("--accordion-content-height", `${content.scrollHeight}px`);

            const finishMobileAnimation = () => {
              window.clearTimeout(fallbackTimer);
              finishAnimation(open);
            };

            accordionAnimation = {
              cancel() {
                window.clearTimeout(fallbackTimer);
              }
            };

            if (open) {
              item.open = true;
              item.classList.remove("is-open");
              void content.offsetHeight;
            }

            requestAnimationFrame(() => {
              if (!accordionAnimation) {
                return;
              }

              content.style.setProperty("--accordion-content-height", `${content.scrollHeight}px`);
              item.classList.toggle("is-open", open);
              fallbackTimer = window.setTimeout(finishMobileAnimation, duration + 70);
            });
            return;
          }

          item.open = true;
          item.dataset.accordionAnimating = "true";
          content.style.overflow = "hidden";

          if (open) {
            const targetHeight = content.scrollHeight;
            const startHeight = wasOpen ? currentHeight : 0;
            item.classList.add("is-animating", "is-opening");
            item.classList.remove("is-closing");
            content.style.height = `${startHeight}px`;
            content.style.opacity = startHeight > 0 ? "1" : "0";
            content.style.transform = startHeight > 0 ? "translateY(0)" : "translateY(-3px)";
            void content.offsetHeight;

            accordionAnimation = content.animate([
              { height: `${startHeight}px`, opacity: startHeight > 0 ? 1 : 0, transform: startHeight > 0 ? "translateY(0)" : "translateY(-3px)" },
              { height: `${targetHeight}px`, opacity: 1, transform: "translateY(0)" }
            ], {
              duration: getAnimationDuration(startHeight, targetHeight, true),
              easing: "cubic-bezier(0.22, 1, 0.36, 1)",
              fill: "forwards"
            });

            accordionAnimation.onfinish = () => finishAnimation(true);
            return;
          }

          const startHeight = currentHeight || content.scrollHeight;
          content.style.height = `${startHeight}px`;
          content.style.opacity = "1";
          content.style.transform = "translateY(0)";
          void content.offsetHeight;
          item.classList.add("is-animating", "is-closing");
          item.classList.remove("is-opening");

          accordionAnimation = content.animate([
            { height: `${startHeight}px`, opacity: 1, transform: "translateY(0)" },
            { height: "0px", opacity: 0, transform: "translateY(-3px)" }
          ], {
            duration: getAnimationDuration(startHeight, 0, false),
            easing: "cubic-bezier(0.4, 0, 0.2, 1)",
            fill: "forwards"
          });

          accordionAnimation.onfinish = () => finishAnimation(false);
        };

        summary.addEventListener("click", (event) => {
          event.preventDefault();
          animateAccordion(!item.open || item.classList.contains("is-closing"));
        });
      });
    });
  };

  const initProductPictureScrollAnimation = () => {
    const galleries = Array.from(document.querySelectorAll("[data-product-gallery]")).filter((gallery) => gallery instanceof HTMLElement);
    if (!galleries.length || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return;
    }

    let ticking = false;
    const updateGalleryMotion = () => {
      ticking = false;
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;

      galleries.forEach((gallery) => {
        const mainImageShell = gallery.querySelector("[data-main-image-shell]");
        if (!(mainImageShell instanceof HTMLElement)) {
          return;
        }

        const rect = mainImageShell.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > viewportHeight) {
          return;
        }

        const progress = (rect.top + rect.height * 0.5 - viewportHeight * 0.5) / viewportHeight;
        const translateY = Math.max(-10, Math.min(10, progress * -18));
        gallery.style.setProperty("--pdp-picture-scroll-y", `${translateY.toFixed(2)}px`);
      });
    };

    const requestGalleryMotion = () => {
      if (ticking) {
        return;
      }

      ticking = true;
      window.requestAnimationFrame(updateGalleryMotion);
    };

    galleries.forEach((gallery) => {
      gallery.classList.add("is-scroll-animated");
    });

    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-scroll-visible");
            requestGalleryMotion();
          }
        });
      }, { threshold: 0.18 });

      galleries.forEach((gallery) => observer.observe(gallery));
    } else {
      galleries.forEach((gallery) => gallery.classList.add("is-scroll-visible"));
    }

    window.addEventListener("scroll", requestGalleryMotion, { passive: true });
    window.addEventListener("resize", requestGalleryMotion);
    requestGalleryMotion();
  };

  const getMappedSwatchColor = (name = "") => {
    const normalized = String(name).trim().toLowerCase();
    if (!normalized) {
      return null;
    }

    if (colorSwatchMap[normalized]) {
      return colorSwatchMap[normalized];
    }

    for (const [key, value] of Object.entries(colorSwatchMap)) {
      if (normalized.includes(key)) {
        return value;
      }
    }

    return null;
  };

  const getExactMappedSwatchColor = (name = "") => {
    const normalized = String(name)
      .trim()
      .toLowerCase()
      .replace(/[-_]+/g, " ")
      .replace(/\s+/g, " ");
    return normalized ? colorSwatchMap[normalized] || null : null;
  };

  const getSplitSwatchColors = (name = "") => {
    const normalized = String(name)
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ");

    if (!normalized || getExactMappedSwatchColor(normalized)) {
      return null;
    }

    const delimiterParts = normalized
      .split(/\s*(?:\/|&|\+|,|\band\b)\s*/)
      .filter(Boolean);

    if (delimiterParts.length === 2) {
      const firstColor = getExactMappedSwatchColor(delimiterParts[0]);
      const secondColor = getExactMappedSwatchColor(delimiterParts[1]);
      return firstColor && secondColor ? [firstColor, secondColor] : null;
    }

    const hyphenParts = normalized
      .split(/\s*-\s*/)
      .filter(Boolean);

    if (hyphenParts.length === 2) {
      const firstColor = getExactMappedSwatchColor(hyphenParts[0]);
      const secondColor = getExactMappedSwatchColor(hyphenParts[1]);
      return firstColor && secondColor ? [firstColor, secondColor] : null;
    }

    const words = normalized.split(" ").filter(Boolean);
    for (let index = 1; index < words.length; index += 1) {
      const firstColorName = words.slice(0, index).join(" ");
      const secondColorName = words.slice(index).join(" ");
      const firstColor = getExactMappedSwatchColor(firstColorName);
      const secondColor = getExactMappedSwatchColor(secondColorName);

      if (firstColor && secondColor) {
        return [firstColor, secondColor];
      }
    }

    return null;
  };

  const getMappedSwatchBackground = (name = "") => {
    const exactColor = getExactMappedSwatchColor(name);
    if (exactColor) {
      return exactColor;
    }

    const splitColors = getSplitSwatchColors(name);
    if (splitColors) {
      return `linear-gradient(135deg, ${splitColors[0]} 0 50%, ${splitColors[1]} 50% 100%)`;
    }

    return getMappedSwatchColor(name);
  };

  const applySwatchBackground = (swatch) => {
    const swatchName = swatch.getAttribute("data-swatch-name") || "";
    const swatchImage = swatch.getAttribute("data-swatch-image") || "";
    const mappedBackground = getMappedSwatchBackground(swatchName);

    if (mappedBackground) {
      swatch.style.background = mappedBackground;
      return;
    }

    sampleImageColor(swatchImage).then((sampledColor) => {
      swatch.style.background = sampledColor || neutralSwatchColor;
    });
  };

  const sampleImageColor = (imageSrc) =>
    new Promise((resolve) => {
      if (!imageSrc) {
        resolve(null);
        return;
      }

      const image = new Image();
      image.crossOrigin = "anonymous";
      image.referrerPolicy = "no-referrer";

      image.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d", { willReadFrequently: true });
          if (!context) {
            resolve(null);
            return;
          }

          const width = 12;
          const height = 12;
          canvas.width = width;
          canvas.height = height;
          context.drawImage(image, 0, 0, width, height);

          const { data } = context.getImageData(0, 0, width, height);
          let red = 0;
          let green = 0;
          let blue = 0;
          let count = 0;

          for (let index = 0; index < data.length; index += 4) {
            const alpha = data[index + 3];
            if (alpha < 128) {
              continue;
            }

            red += data[index];
            green += data[index + 1];
            blue += data[index + 2];
            count += 1;
          }

          if (!count) {
            resolve(null);
            return;
          }

          const toHex = (value) => Math.round(value).toString(16).padStart(2, "0");
          resolve(`#${toHex(red / count)}${toHex(green / count)}${toHex(blue / count)}`);
        } catch (error) {
          resolve(null);
        }
      };

      image.onerror = () => resolve(null);
      image.src = imageSrc;
    });

  const initProductCardSwatches = (root = document) => {
    const scope = root && typeof root.querySelectorAll === "function" ? root : document;
    scope.querySelectorAll("[data-swatch]").forEach((swatch) => {
      applySwatchBackground(swatch);
    });
  };

  const initHomeRandomProductRails = () => {
    document.querySelectorAll("[data-random-product-rail]").forEach((grid) => {
      if (!(grid instanceof HTMLElement) || grid.dataset.randomized === "true") {
        return;
      }

      const cards = Array.from(grid.querySelectorAll("[data-random-product-card]"))
        .filter((card) => card instanceof HTMLElement);
      const visibleCount = Number.parseInt(grid.getAttribute("data-randomize-count") || "4", 10);
      const count = Math.max(1, Math.min(Number.isFinite(visibleCount) ? visibleCount : 4, cards.length));

      if (!cards.length) {
        return;
      }

      const shuffledCards = [...cards];
      for (let index = shuffledCards.length - 1; index > 0; index -= 1) {
        const randomIndex = Math.floor(Math.random() * (index + 1));
        [shuffledCards[index], shuffledCards[randomIndex]] = [shuffledCards[randomIndex], shuffledCards[index]];
      }

      const selectedList = shuffledCards.slice(0, count);
      const selectedCards = new Set(selectedList);
      const selectedPositions = new Map(selectedList.map((card, index) => [card, index]));
      const selectedFragment = document.createDocumentFragment();
      const hiddenFragment = document.createDocumentFragment();

      shuffledCards.forEach((card) => {
        const isSelected = selectedCards.has(card);
        card.hidden = !isSelected;
        card.toggleAttribute("aria-hidden", !isSelected);

        card.querySelectorAll("img").forEach((image) => {
          if (!(image instanceof HTMLImageElement)) {
            return;
          }

          if (isSelected) {
            const selectedPosition = selectedPositions.get(card) || 0;
            primeImageLoad(image, selectedPosition < 2 ? "high" : "low");
            return;
          }

          if (!image.complete || image.naturalWidth === 0) {
            image.loading = "lazy";
          }
          if (image.getAttribute("fetchpriority") === "high") {
            image.setAttribute("fetchpriority", "low");
          }
          if ("fetchPriority" in image) {
            image.fetchPriority = "low";
          }
        });

        (isSelected ? selectedFragment : hiddenFragment).appendChild(card);
      });

      grid.appendChild(selectedFragment);
      grid.appendChild(hiddenFragment);
      grid.dataset.randomized = "true";
      initProductCardSwatches(grid);
      initReviewsIoRatingSnippets(grid);
    });
  };

  const initCollectionFilters = () => {
    const filterForms = Array.from(document.querySelectorAll("[data-collection-filter-form]"));
    const sortDropdowns = Array.from(document.querySelectorAll("[data-sort-dropdown]"));
    const filterDrawerTriggers = Array.from(document.querySelectorAll("[data-filter-drawer-open]"));
    const sortDrawerTriggers = Array.from(document.querySelectorAll("[data-sort-drawer-open]"));
    const filterDrawerClosers = Array.from(document.querySelectorAll("[data-filter-drawer-close]"));
    const sortDrawerClosers = Array.from(document.querySelectorAll("[data-sort-drawer-close]"));
    if (!filterForms.length && !sortDropdowns.length) {
      return;
    }

    const setFilterDrawerOpen = (nextOpen) => {
      document.body.classList.toggle("collection-filter-open", nextOpen);
    };

    const setSortDrawerOpen = (nextOpen) => {
      document.body.classList.toggle("collection-sort-open", nextOpen);
    };

    const closeOtherGroups = (activeGroup) => {
      document.querySelectorAll("[data-filter-group]").forEach((group) => {
        if (group !== activeGroup) {
          group.removeAttribute("open");
        }
      });

      sortDropdowns.forEach((dropdown) => {
        if (dropdown !== activeGroup) {
          dropdown.removeAttribute("open");
        }
      });
    };

    filterForms.forEach((form) => {
      const isMobileFilterForm = form.hasAttribute("data-mobile-filter-form");
      const updateFilterSelectionState = () => {
        form.querySelectorAll("[data-filter-input]").forEach((input) => {
          const option = input.closest(".filter-panel-option, .drawer-filter-option");
          if (option instanceof HTMLElement) {
            option.classList.toggle("is-selected", input.checked);
          }
        });

        form.querySelectorAll("[data-filter-group]").forEach((group) => {
          const minInput = group.querySelector("[data-filter-price-min]");
          const maxInput = group.querySelector("[data-filter-price-max]");
          if (!(minInput instanceof HTMLInputElement) || !(maxInput instanceof HTMLInputElement)) {
            return;
          }

          const hasPriceSelection = Boolean(minInput.value || maxInput.value);
          group.classList.toggle("has-selection", hasPriceSelection);
          const summary = group.querySelector(".collection-filter-button");
          if (summary instanceof HTMLElement) {
            summary.classList.toggle("has-selection", hasPriceSelection);
          }
        });
      };

      form.querySelectorAll("[data-filter-group]").forEach((group) => {
        group.addEventListener("toggle", () => {
          if (group.open) {
            closeOtherGroups(group);
          }
        });
      });

      form.querySelectorAll("[data-filter-input]").forEach((input) => {
        input.addEventListener("change", () => {
          updateFilterSelectionState();
          if (!isMobileFilterForm) {
            form.requestSubmit();
          }
        });
      });

      form.querySelectorAll("[data-filter-price-range-option]").forEach((button) => {
        button.addEventListener("click", () => {
          const minInput = form.querySelector("[data-filter-price-min]");
          const maxInput = form.querySelector("[data-filter-price-max]");
          if (!(minInput instanceof HTMLInputElement) || !(maxInput instanceof HTMLInputElement)) {
            return;
          }

          form.querySelectorAll("[data-filter-price-range-option]").forEach((candidate) => {
            candidate.classList.remove("is-selected");
          });

          button.classList.add("is-selected");
          minInput.value = button.getAttribute("data-price-min") || "";
          maxInput.value = button.getAttribute("data-price-max") || "";
          if (!isMobileFilterForm) {
            form.requestSubmit();
          }
        });
      });

      form.querySelectorAll("[data-filter-close]").forEach((button) => {
        button.addEventListener("click", () => {
          button.closest("[data-filter-group]")?.removeAttribute("open");
        });
      });

      form.querySelectorAll("[data-drawer-filter-group]").forEach((group) => {
        group.addEventListener("toggle", () => {
          if (!group.open) {
            return;
          }

          form.querySelectorAll("[data-drawer-filter-group]").forEach((candidate) => {
            if (candidate !== group) {
              candidate.removeAttribute("open");
            }
          });
        });
      });

      updateFilterSelectionState();
    });

    sortDropdowns.forEach((dropdown) => {
      dropdown.addEventListener("toggle", () => {
        if (dropdown.open) {
          document.querySelectorAll("[data-filter-group]").forEach((group) => {
            group.removeAttribute("open");
          });

          sortDropdowns.forEach((candidate) => {
            if (candidate !== dropdown) {
              candidate.removeAttribute("open");
            }
          });
        }
      });
    });

    document.querySelectorAll("[data-sort-form]").forEach((form) => {
      const sortInput = form.querySelector("[data-sort-input]");
      const sortOptions = Array.from(form.querySelectorAll("[data-sort-option]"));
      const sortDropdown = form.querySelector("[data-sort-dropdown]");

      sortOptions.forEach((option) => {
        option.addEventListener("click", () => {
          const sortValue = option.getAttribute("data-sort-value");
          if (!sortValue || !(sortInput instanceof HTMLInputElement)) {
            return;
          }

          sortInput.value = sortValue;

          const formData = new FormData(form);
          const nextUrl = new URL(window.location.href);
          nextUrl.search = "";

          for (const [key, value] of formData.entries()) {
            if (typeof value === "string" && value !== "") {
              nextUrl.searchParams.append(key, value);
            }
          }

          sortDropdown?.removeAttribute("open");
          setSortDrawerOpen(false);
          window.location.assign(nextUrl.toString());
        });
      });
    });

    filterDrawerTriggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        setSortDrawerOpen(false);
        setFilterDrawerOpen(true);
      });
    });

    sortDrawerTriggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        setFilterDrawerOpen(false);
        setSortDrawerOpen(true);
      });
    });

    filterDrawerClosers.forEach((button) => {
      button.addEventListener("click", () => {
        setFilterDrawerOpen(false);
      });
    });

    sortDrawerClosers.forEach((button) => {
      button.addEventListener("click", () => {
        setSortDrawerOpen(false);
      });
    });

    document.addEventListener("click", (event) => {
      const target = event.target;
      if (!(target instanceof Element) || target.closest("[data-collection-filter-form]") || target.closest("[data-sort-form]")) {
        return;
      }

      document.querySelectorAll("[data-filter-group]").forEach((group) => {
        group.removeAttribute("open");
      });

      sortDropdowns.forEach((dropdown) => {
        dropdown.removeAttribute("open");
      });
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        setFilterDrawerOpen(false);
        setSortDrawerOpen(false);
      }
    });
  };

  const imagePrefetchState = {
    images: new Set(),
    documents: new Set(),
    nextRowWarmed: false
  };

  const scheduleIdle = (callback) => {
    if (typeof window === "undefined") {
      return;
    }
    if (typeof window.requestIdleCallback === "function") {
      window.requestIdleCallback(callback, { timeout: 600 });
    } else {
      window.setTimeout(callback, 120);
    }
  };

  const prefetchImageUrl = (url) => {
    if (!url || imagePrefetchState.images.has(url)) {
      return;
    }
    imagePrefetchState.images.add(url);
    const img = new Image();
    img.decoding = "async";
    if ("fetchPriority" in img) {
      img.fetchPriority = "low";
    }
    img.src = url;
  };

  const prefetchCardImages = (card) => {
    if (!(card instanceof Element)) {
      return;
    }
    const img = card.querySelector("img");
    if (!(img instanceof HTMLImageElement)) {
      return;
    }
    const candidate = img.currentSrc || img.src;
    if (candidate) {
      prefetchImageUrl(candidate);
    }
  };

  const supportsLinkRel = (() => {
    if (typeof document === "undefined") {
      return false;
    }
    try {
      const link = document.createElement("link");
      return Boolean(link.relList && link.relList.supports && link.relList.supports("prefetch"));
    } catch (_error) {
      return false;
    }
  })();

  const queueDocumentPrefetch = (url) => {
    if (!supportsLinkRel || !url || imagePrefetchState.documents.has(url)) {
      return;
    }
    imagePrefetchState.documents.add(url);
    scheduleIdle(() => {
      const link = document.createElement("link");
      link.rel = "prefetch";
      link.href = url;
      link.as = "document";
      document.head.appendChild(link);
    });
  };

  const initImagePrefetch = () => {
    if (typeof document === "undefined" || isShopifyDesignMode) {
      return;
    }

    const handleIntent = (event) => {
      const target = event.target;
      if (!(target instanceof Element)) {
        return;
      }
      const card = target.closest("a.product-card, a.search-result-card, a.mini-product");
      if (!(card instanceof HTMLAnchorElement)) {
        return;
      }
      prefetchCardImages(card);
      const href = card.getAttribute("href");
      if (!href || href === "#" || href.startsWith("javascript:")) {
        return;
      }
      try {
        const resolved = new URL(href, window.location.origin);
        if (resolved.origin === window.location.origin) {
          queueDocumentPrefetch(resolved.pathname + resolved.search);
        }
      } catch (_error) {
        /* ignore */
      }
    };

    document.addEventListener("mouseenter", handleIntent, { capture: true, passive: true });
    document.addEventListener("focusin", handleIntent, { passive: true });

    const warmNextRow = () => {
      if (imagePrefetchState.nextRowWarmed) {
        return;
      }
      const grid = document.querySelector(".collection-grid, .product-grid");
      if (!grid) {
        return;
      }
      const lazyImages = Array.from(grid.querySelectorAll('img[loading="lazy"]'))
        .filter((img) => img instanceof HTMLImageElement && (!img.complete || img.naturalWidth === 0))
        .slice(0, 4);
      if (!lazyImages.length) {
        return;
      }
      imagePrefetchState.nextRowWarmed = true;
      lazyImages.forEach((img) => {
        img.loading = "eager";
        if ("fetchPriority" in img) {
          img.fetchPriority = "low";
        }
      });
    };

    const triggerNextRowWarmup = () => scheduleIdle(warmNextRow);

    if (document.readyState === "complete") {
      triggerNextRowWarmup();
    } else {
      window.addEventListener("load", triggerNextRowWarmup, { once: true });
    }
  };

  const eagerLoadCartDrawerImages = () => {
    const drawer = document.querySelector(".cart-drawer");
    if (!drawer) {
      return;
    }
    drawer.querySelectorAll('img[loading="lazy"]').forEach((img) => {
      if (!(img instanceof HTMLImageElement)) {
        return;
      }
      if (img.complete && img.naturalWidth > 0) {
        return;
      }
      const rect = img.getBoundingClientRect();
      const drawerRect = drawer.getBoundingClientRect();
      const isVisible = rect.width > 0 && rect.height > 0 && rect.bottom >= drawerRect.top && rect.top <= drawerRect.bottom;
      if (!isVisible) {
        return;
      }
      primeImageLoad(img);
    });
  };

  const bindCartDrawerImageWarmup = () => {
    const cartBody = document.querySelector(".cart-drawer .cart-body");
    if (!(cartBody instanceof HTMLElement) || cartBody.dataset.imageWarmupBound === "true") {
      return;
    }

    cartBody.dataset.imageWarmupBound = "true";
    let isTicking = false;
    const scheduleWarmup = () => {
      if (isTicking) {
        return;
      }

      isTicking = true;
      window.requestAnimationFrame(() => {
        isTicking = false;
        eagerLoadCartDrawerImages();
      });
    };

    cartBody.addEventListener("scroll", scheduleWarmup, { passive: true });
  };

  const bindGlobalEvents = () => {
    if (document.body.dataset.globalEventsBound === "true") {
      return;
    }
    document.body.dataset.globalEventsBound = "true";

    document.addEventListener("click", (event) => {
      const target = event.target;
      if (!(target instanceof Element)) {
        return;
      }

      const legacyFullOutfitsLink = target.closest("a[href]");
      if (!(legacyFullOutfitsLink instanceof HTMLAnchorElement) || !isLegacyFullOutfitsUrl(legacyFullOutfitsLink.getAttribute("href"))) {
        return;
      }

      event.preventDefault();
      window.location.href = fullOutfitsPath;
    }, true);

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        closeAllDesktopMenus();
        setMobileMenuOpen(false);
        setCartDrawerOpen(false);
        setSearchOpen(false);
      }
    });

    document.addEventListener("click", (event) => {
      const target = event.target;
      if (!(target instanceof Element)) {
        return;
      }

      const searchToggle = target.closest("[data-search-toggle]");
      if (searchToggle) {
        event.preventDefault();
        setMobileMenuOpen(false);
        setCartDrawerOpen(false);
        setSearchOpen(!document.body.classList.contains("search-open"));
      }

      const searchClose = target.closest(".search-close, .search-overlay");
      if (searchClose) {
        event.preventDefault();
        setSearchOpen(false);
      }

      const cartToggle = target.closest("[data-cart-toggle]");
      if (cartToggle) {
        event.preventDefault();
        setSearchOpen(false);
        setCartDrawerOpen(!document.body.classList.contains("cart-open"));
      }

      const cartClose = target.closest(".cart-close, .cart-overlay");
      if (cartClose) {
        event.preventDefault();
        setCartDrawerOpen(false);
      }

      const cartContinue = target.closest("[data-cart-continue]");
      if (cartContinue) {
        event.preventDefault();
        setCartDrawerOpen(false);
      }
    });

    let resizeTimer = null;
    window.addEventListener("resize", () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        if (window.innerWidth > 820) {
          setMobileMenuOpen(false);
        }
      }, 120);
    }, { passive: true });
  };

  redirectLegacyFullOutfitsPage();
  normalizeLegacyFullOutfitsLinks();
  initNavigation();
  initCartDrawer();
  initNewsletter();
  initContactForms();
  initSearch();
  initProductGallery();
  initProductForms();
  initProductBundles();
  initProductAccordions();
  initProductPictureScrollAnimation();
  initProductCardSwatches();
  initReviewsIoRatingSnippets();
  initHomeRandomProductRails();
  initCollectionFilters();
  initImagePrefetch();
  bindGlobalEvents();
})();
